// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%27160%27 height=%27160%27><filter id=%27n%27><feTurbulence type=%27fractalNoise%27 baseFrequency=%270.9%27 numOctaves=%272%27 stitchTiles=%27stitch%27/><feColorMatrix values=%270 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0%27/></filter><rect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23n%29%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800;900&family=DM+Sans:wght@400;500;600;700&family=Caveat:wght@400;700&family=JetBrains+Mono:wght@400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*/
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
:root {
    --background: 60 25% 97%;
    --foreground: 222 13% 5%;
    --card: 0 0% 100%;
    --card-foreground: 222 13% 5%;
    --popover: 0 0% 100%;
    --popover-foreground: 222 13% 5%;
    --primary: 173 80% 43%;
    --primary-foreground: 0 0% 100%;
    --secondary: 60 14% 92%;
    --secondary-foreground: 222 13% 5%;
    --muted: 60 14% 92%;
    --muted-foreground: 220 9% 50%;
    --accent: 9 100% 71%;
    --accent-foreground: 0 0% 100%;
    --destructive: 0 80% 60%;
    --destructive-foreground: 0 0% 100%;
    --border: 38 24% 89%;
    --input: 38 24% 89%;
    --ring: 173 80% 43%;
    --radius: 1.25rem;
  }
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-\\[3px\\]{
  inset: 3px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-x-3{
  left: 0.75rem;
  right: 0.75rem;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-1{
  bottom: -0.25rem;
}
.-bottom-10{
  bottom: -2.5rem;
}
.-bottom-12{
  bottom: -3rem;
}
.-bottom-6{
  bottom: -1.5rem;
}
.-left-12{
  left: -3rem;
}
.-right-1{
  right: -0.25rem;
}
.-right-10{
  right: -2.5rem;
}
.-right-12{
  right: -3rem;
}
.-right-3{
  right: -0.75rem;
}
.-right-6{
  right: -1.5rem;
}
.-start-3{
  inset-inline-start: -0.75rem;
}
.-top-1{
  top: -0.25rem;
}
.-top-12{
  top: -3rem;
}
.-top-3{
  top: -0.75rem;
}
.-top-5{
  top: -1.25rem;
}
.-top-6{
  top: -1.5rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-2{
  bottom: 0.5rem;
}
.bottom-24{
  bottom: 6rem;
}
.bottom-3{
  bottom: 0.75rem;
}
.bottom-4{
  bottom: 1rem;
}
.end-0{
  inset-inline-end: 0px;
}
.end-3{
  inset-inline-end: 0.75rem;
}
.end-4{
  inset-inline-end: 1rem;
}
.end-6{
  inset-inline-end: 1.5rem;
}
.left-0{
  left: 0px;
}
.left-0\\.5{
  left: 0.125rem;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-3{
  left: 0.75rem;
}
.left-3\\.5{
  left: 0.875rem;
}
.left-4{
  left: 1rem;
}
.left-6{
  left: 1.5rem;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-5{
  right: 1.25rem;
}
.right-6{
  right: 1.5rem;
}
.start-0{
  inset-inline-start: 0px;
}
.start-2{
  inset-inline-start: 0.5rem;
}
.top-0{
  top: 0px;
}
.top-0\\.5{
  top: 0.125rem;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-6{
  top: 1.5rem;
}
.top-7{
  top: 1.75rem;
}
.top-8{
  top: 2rem;
}
.top-\\[1px\\]{
  top: 1px;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[60\\%\\]{
  top: 60%;
}
.top-\\[7px\\]{
  top: 7px;
}
.top-full{
  top: 100%;
}
.-z-0{
  z-index: 0;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[80\\]{
  z-index: 80;
}
.z-\\[90\\]{
  z-index: 90;
}
.order-1{
  order: 1;
}
.order-2{
  order: 2;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-full{
  grid-column: 1 / -1;
}
.row-span-1{
  grid-row: span 1 / span 1;
}
.row-span-2{
  grid-row: span 2 / span 2;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-2{
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.-mx-4{
  margin-left: -1rem;
  margin-right: -1rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.-ml-2{
  margin-left: -0.5rem;
}
.-ml-4{
  margin-left: -1rem;
}
.-mr-1{
  margin-right: -0.25rem;
}
.-ms-1{
  margin-inline-start: -0.25rem;
}
.-mt-0\\.5{
  margin-top: -0.125rem;
}
.-mt-1{
  margin-top: -0.25rem;
}
.-mt-4{
  margin-top: -1rem;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.me-1{
  margin-inline-end: 0.25rem;
}
.me-1\\.5{
  margin-inline-end: 0.375rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.ms-1{
  margin-inline-start: 0.25rem;
}
.ms-2{
  margin-inline-start: 0.5rem;
}
.ms-3{
  margin-inline-start: 0.75rem;
}
.ms-auto{
  margin-inline-start: auto;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-14{
  margin-top: 3.5rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-2\\.5{
  margin-top: 0.625rem;
}
.mt-24{
  margin-top: 6rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-auto{
  margin-top: auto;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-28{
  height: 7rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-56{
  height: 14rem;
}
.h-6{
  height: 1.5rem;
}
.h-60{
  height: 15rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[150px\\]{
  height: 150px;
}
.h-\\[160px\\]{
  height: 160px;
}
.h-\\[17px\\]{
  height: 17px;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[420px\\]{
  height: 420px;
}
.h-\\[520px\\]{
  height: 520px;
}
.h-\\[80\\%\\]{
  height: 80%;
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
  height: var(--radix-select-trigger-height);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-40{
  max-height: 10rem;
}
.max-h-60{
  max-height: 15rem;
}
.max-h-80{
  max-height: 20rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[--radix-context-menu-content-available-height\\]{
  max-height: var(--radix-context-menu-content-available-height);
}
.max-h-\\[--radix-select-content-available-height\\]{
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[100vh\\]{
  max-height: 100vh;
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[35vh\\]{
  max-height: 35vh;
}
.max-h-\\[60vh\\]{
  max-height: 60vh;
}
.max-h-\\[70vh\\]{
  max-height: 70vh;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[92vh\\]{
  max-height: 92vh;
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\]{
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-0{
  min-height: 0px;
}
.min-h-\\[100px\\]{
  min-height: 100px;
}
.min-h-\\[110px\\]{
  min-height: 110px;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-\\[80px\\]{
  min-height: 80px;
}
.min-h-screen{
  min-height: 100vh;
}
.w-0{
  width: 0px;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-2\\/3{
  width: 66.666667%;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-5{
  width: 1.25rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-60{
  width: 15rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[112px\\]{
  width: 112px;
}
.w-\\[120px\\]{
  width: 120px;
}
.w-\\[17px\\]{
  width: 17px;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-\\[320px\\]{
  width: 320px;
}
.w-\\[72\\%\\]{
  width: 72%;
}
.w-\\[88\\%\\]{
  width: 88%;
}
.w-\\[calc\\(100\\%-1rem\\)\\]{
  width: calc(100% - 1rem);
}
.w-\\[calc\\(100vw-2\\.5rem\\)\\]{
  width: calc(100vw - 2.5rem);
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-10{
  min-width: 2.5rem;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-9{
  min-width: 2.25rem;
}
.min-w-\\[12rem\\]{
  min-width: 12rem;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width);
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[140px\\]{
  max-width: 140px;
}
.max-w-\\[180px\\]{
  max-width: 180px;
}
.max-w-\\[380px\\]{
  max-width: 380px;
}
.max-w-\\[45\\%\\]{
  max-width: 45%;
}
.max-w-\\[48px\\]{
  max-width: 48px;
}
.max-w-\\[80\\%\\]{
  max-width: 80%;
}
.max-w-\\[85\\%\\]{
  max-width: 85%;
}
.max-w-\\[calc\\(100vw-1rem\\)\\]{
  max-width: calc(100vw - 1rem);
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-max{
  max-width: max-content;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.basis-full{
  flex-basis: 100%;
}
.caption-bottom{
  caption-side: bottom;
}
.border-collapse{
  border-collapse: collapse;
}
.origin-\\[--radix-context-menu-content-transform-origin\\]{
  transform-origin: var(--radix-context-menu-content-transform-origin);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\]{
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-hover-card-content-transform-origin\\]{
  transform-origin: var(--radix-hover-card-content-transform-origin);
}
.origin-\\[--radix-menubar-content-transform-origin\\]{
  transform-origin: var(--radix-menubar-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\]{
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\]{
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\]{
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[1px\\]{
  --tw-translate-x: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-0\\.5{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[1px\\]{
  --tw-translate-y: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-5{
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-3{
  --tw-translate-y: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-12{
  --tw-rotate: 12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[-18deg\\]{
  --tw-rotate: -18deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[-1deg\\]{
  --tw-rotate: -1deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[-2deg\\]{
  --tw-rotate: -2deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[-3deg\\]{
  --tw-rotate: -3deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[-6deg\\]{
  --tw-rotate: -6deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[18deg\\]{
  --tw-rotate: 18deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.96\\]{
  --tw-scale-x: 0.96;
  --tw-scale-y: 0.96;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.animate-\\[marquee_28s_linear_infinite\\]{
  animation: marquee 28s linear infinite;
}
@keyframes bounce{
  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }
  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce{
  animation: bounce 1s infinite;
}
@keyframes ping{
  75%, 100%{
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse{
  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-e-resize{
  cursor: e-resize;
}
.cursor-grab{
  cursor: grab;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-w-resize{
  cursor: w-resize;
}
.touch-none{
  touch-action: none;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize-none{
  resize: none;
}
.snap-x{
  scroll-snap-type: x var(--tw-scroll-snap-strictness);
}
.snap-start{
  scroll-snap-align: start;
}
.list-inside{
  list-style-position: inside;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  appearance: none;
}
.auto-rows-\\[120px\\]{
  grid-auto-rows: 120px;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.gap-\\[2px\\]{
  gap: 2px;
}
.-space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.-space-x-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-1.25rem * var(--tw-space-x-reverse));
  margin-left: calc(-1.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-3\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.875rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.875rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-\\[\\#E8E5DD\\] > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(232 229 221 / var(--tw-divide-opacity, 1));
}
.divide-\\[\\#F0EDE3\\] > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(240 237 227 / var(--tw-divide-opacity, 1));
}
.self-start{
  align-self: flex-start;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-none{
  border-radius: 0px;
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-t-3xl{
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-bl-md{
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.rounded-bl-none{
  border-bottom-left-radius: 0px;
}
.rounded-br-md{
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.rounded-br-none{
  border-bottom-right-radius: 0px;
}
.rounded-tl-sm{
  border-top-left-radius: calc(var(--radius) - 4px);
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-\\[6px\\]{
  border-width: 6px;
}
.border-x{
  border-left-width: 1px;
  border-right-width: 1px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-y-2{
  border-top-width: 2px;
  border-bottom-width: 2px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l{
  border-left-width: 1px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-t-4{
  border-top-width: 4px;
}
.border-dashed{
  border-style: dashed;
}
.border-none{
  border-style: none;
}
.border-\\[\\#00CE9E\\]{
  --tw-border-opacity: 1;
  border-color: rgb(0 206 158 / var(--tw-border-opacity, 1));
}
.border-\\[\\#00CED1\\]{
  --tw-border-opacity: 1;
  border-color: rgb(0 206 209 / var(--tw-border-opacity, 1));
}
.border-\\[\\#0A0B0D\\]{
  --tw-border-opacity: 1;
  border-color: rgb(10 11 13 / var(--tw-border-opacity, 1));
}
.border-\\[\\#0A0B0D\\]\\/10{
  border-color: rgb(10 11 13 / 0.1);
}
.border-\\[\\#0A0B0D\\]\\/5{
  border-color: rgb(10 11 13 / 0.05);
}
.border-\\[\\#0F1115\\]{
  --tw-border-opacity: 1;
  border-color: rgb(15 17 21 / var(--tw-border-opacity, 1));
}
.border-\\[\\#0F1115\\]\\/10{
  border-color: rgb(15 17 21 / 0.1);
}
.border-\\[\\#0F1115\\]\\/15{
  border-color: rgb(15 17 21 / 0.15);
}
.border-\\[\\#121212\\]{
  --tw-border-opacity: 1;
  border-color: rgb(18 18 18 / var(--tw-border-opacity, 1));
}
.border-\\[\\#121212\\]\\/10{
  border-color: rgb(18 18 18 / 0.1);
}
.border-\\[\\#121212\\]\\/15{
  border-color: rgb(18 18 18 / 0.15);
}
.border-\\[\\#121212\\]\\/20{
  border-color: rgb(18 18 18 / 0.2);
}
.border-\\[\\#14C8B0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(20 200 176 / var(--tw-border-opacity, 1));
}
.border-\\[\\#14C8B0\\]\\/30{
  border-color: rgb(20 200 176 / 0.3);
}
.border-\\[\\#A78BFA\\]{
  --tw-border-opacity: 1;
  border-color: rgb(167 139 250 / var(--tw-border-opacity, 1));
}
.border-\\[\\#B49CFF\\]{
  --tw-border-opacity: 1;
  border-color: rgb(180 156 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#B49CFF\\]\\/40{
  border-color: rgb(180 156 255 / 0.4);
}
.border-\\[\\#D14848\\]\\/20{
  border-color: rgb(209 72 72 / 0.2);
}
.border-\\[\\#D8D3C2\\]{
  --tw-border-opacity: 1;
  border-color: rgb(216 211 194 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E2DFD4\\]{
  --tw-border-opacity: 1;
  border-color: rgb(226 223 212 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E8E5DD\\]{
  --tw-border-opacity: 1;
  border-color: rgb(232 229 221 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EFEEE6\\]{
  --tw-border-opacity: 1;
  border-color: rgb(239 238 230 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F4F1E8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(244 241 232 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F9C349\\]{
  --tw-border-opacity: 1;
  border-color: rgb(249 195 73 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FF4E5B\\]{
  --tw-border-opacity: 1;
  border-color: rgb(255 78 91 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FF7A6B\\]{
  --tw-border-opacity: 1;
  border-color: rgb(255 122 107 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FF7A6B\\]\\/20{
  border-color: rgb(255 122 107 / 0.2);
}
.border-\\[\\#FF7A6B\\]\\/30{
  border-color: rgb(255 122 107 / 0.3);
}
.border-\\[\\#FF8A75\\]{
  --tw-border-opacity: 1;
  border-color: rgb(255 138 117 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FFC93C\\]{
  --tw-border-opacity: 1;
  border-color: rgb(255 201 60 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FFE6E0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(255 230 224 / var(--tw-border-opacity, 1));
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-blue-400{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.border-current{
  border-color: currentColor;
}
.border-destructive{
  border-color: hsl(var(--destructive));
}
.border-destructive\\/50{
  border-color: hsl(var(--destructive) / 0.5);
}
.border-ink{
  --tw-border-opacity: 1;
  border-color: rgb(10 11 13 / var(--tw-border-opacity, 1));
}
.border-ink\\/10{
  border-color: rgb(10 11 13 / 0.1);
}
.border-ink\\/20{
  border-color: rgb(10 11 13 / 0.2);
}
.border-input{
  border-color: hsl(var(--input));
}
.border-primary{
  border-color: hsl(var(--primary));
}
.border-primary\\/50{
  border-color: hsl(var(--primary) / 0.5);
}
.border-transparent{
  border-color: transparent;
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/25{
  border-color: rgb(255 255 255 / 0.25);
}
.border-white\\/30{
  border-color: rgb(255 255 255 / 0.3);
}
.border-zinc-200{
  --tw-border-opacity: 1;
  border-color: rgb(228 228 231 / var(--tw-border-opacity, 1));
}
.border-zinc-300{
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity, 1));
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-t-transparent{
  border-top-color: transparent;
}
.bg-\\[\\#00B4D8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 180 216 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#00CED1\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 206 209 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#00CED1\\]\\/15{
  background-color: rgb(0 206 209 / 0.15);
}
.bg-\\[\\#0A0B0D\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(10 11 13 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0A0B0D\\]\\/55{
  background-color: rgb(10 11 13 / 0.55);
}
.bg-\\[\\#0A0B0D\\]\\/60{
  background-color: rgb(10 11 13 / 0.6);
}
.bg-\\[\\#0A0B0D\\]\\/80{
  background-color: rgb(10 11 13 / 0.8);
}
.bg-\\[\\#0B0B0F\\]\\/95{
  background-color: rgb(11 11 15 / 0.95);
}
.bg-\\[\\#0F1115\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 17 21 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0F1115\\]\\/40{
  background-color: rgb(15 17 21 / 0.4);
}
.bg-\\[\\#121212\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(18 18 18 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#121212\\]\\/40{
  background-color: rgb(18 18 18 / 0.4);
}
.bg-\\[\\#14C8B0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(20 200 176 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1F1F1F\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(31 31 31 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#22C55E\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#22D3EE\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(34 211 238 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2A2A2A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(42 42 42 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#34D399\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#60A5FA\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#9D5DFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(157 93 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#A78BFA\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(167 139 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#B49CFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(180 156 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#BFE9D6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(191 233 214 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D14848\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(209 72 72 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D4F1F4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(212 241 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D8D3C2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(216 211 194 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D9CFFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(217 207 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#DDF5EA\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(221 245 234 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#DEF1F5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(222 241 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E0F7F6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(224 247 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E2DFD4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(226 223 212 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E2F3E4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(226 243 228 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E5E2D6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(229 226 214 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E6FBF9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(230 251 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E879F9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(232 121 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8F7F2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(232 247 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EBE4FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(235 228 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ECE6FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(236 230 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EFEEE6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(239 238 230 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F472B6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 114 182 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F4F1E8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 241 232 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F4F1EA\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 241 234 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F4F2ED\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 242 237 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F4F4F0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5F5F3\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F7F7F2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F7F7F2\\]\\/85{
  background-color: rgb(247 247 242 / 0.85);
}
.bg-\\[\\#F9C349\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 195 73 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F9C349\\]\\/30{
  background-color: rgb(249 195 73 / 0.3);
}
.bg-\\[\\#F9C349\\]\\/40{
  background-color: rgb(249 195 73 / 0.4);
}
.bg-\\[\\#FAF8F2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(250 248 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FB923C\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FBBF24\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF4E5B\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 78 91 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF6B6B\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 107 107 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF7A6B\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 122 107 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF7B6B\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 123 107 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF8AB6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 138 182 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFE08A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 224 138 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFE4E1\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 225 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFE6E0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 230 224 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFE6E0\\]\\/20{
  background-color: rgb(255 230 224 / 0.2);
}
.bg-\\[\\#FFF0C2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 240 194 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFF0D4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 240 212 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFF1D6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 214 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFF3CD\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 243 205 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFF6E0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 246 224 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFF6F4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 246 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFF7E0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 224 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFFDF7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 253 247 / var(--tw-bg-opacity, 1));
}
.bg-accent{
  background-color: hsl(var(--accent));
}
.bg-background{
  background-color: hsl(var(--background));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/0{
  background-color: rgb(0 0 0 / 0);
}
.bg-black\\/20{
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/60{
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/75{
  background-color: rgb(0 0 0 / 0.75);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-black\\/85{
  background-color: rgb(0 0 0 / 0.85);
}
.bg-black\\/95{
  background-color: rgb(0 0 0 / 0.95);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-border{
  background-color: hsl(var(--border));
}
.bg-card{
  background-color: hsl(var(--card));
}
.bg-destructive{
  background-color: hsl(var(--destructive));
}
.bg-foreground{
  background-color: hsl(var(--foreground));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-ink{
  --tw-bg-opacity: 1;
  background-color: rgb(10 11 13 / var(--tw-bg-opacity, 1));
}
.bg-muted{
  background-color: hsl(var(--muted));
}
.bg-muted\\/50{
  background-color: hsl(var(--muted) / 0.5);
}
.bg-popover{
  background-color: hsl(var(--popover));
}
.bg-primary{
  background-color: hsl(var(--primary));
}
.bg-primary\\/10{
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/20{
  background-color: hsl(var(--primary) / 0.2);
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-secondary{
  background-color: hsl(var(--secondary));
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/15{
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/25{
  background-color: rgb(255 255 255 / 0.25);
}
.bg-white\\/70{
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95{
  background-color: rgb(255 255 255 / 0.95);
}
.bg-zinc-100{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
}
.bg-zinc-400{
  --tw-bg-opacity: 1;
  background-color: rgb(161 161 170 / var(--tw-bg-opacity, 1));
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t{
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-\\[\\#00CED1\\]{
  --tw-gradient-from: #00CED1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 206 209 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#0F9D8F\\]{
  --tw-gradient-from: #0F9D8F var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 157 143 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#14C8B0\\]{
  --tw-gradient-from: #14C8B0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 200 176 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#14C8B0\\]\\/10{
  --tw-gradient-from: rgb(20 200 176 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 200 176 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#5EEAD4\\]{
  --tw-gradient-from: #5EEAD4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(94 234 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#B49CFF\\]{
  --tw-gradient-from: #B49CFF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(180 156 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#DDF5EA\\]{
  --tw-gradient-from: #DDF5EA var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(221 245 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#DEF1F5\\]{
  --tw-gradient-from: #DEF1F5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(222 241 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#E8E3D6\\]{
  --tw-gradient-from: #E8E3D6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(232 227 214 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#ECE6FF\\]{
  --tw-gradient-from: #ECE6FF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 230 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#F4F2ED\\]{
  --tw-gradient-from: #F4F2ED var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 242 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#F9C349\\]{
  --tw-gradient-from: #F9C349 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 195 73 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FF7A6B\\]{
  --tw-gradient-from: #FF7A6B var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 122 107 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FFE08A\\]{
  --tw-gradient-from: #FFE08A var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 224 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FFE6E0\\]{
  --tw-gradient-from: #FFE6E0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 230 224 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FFF1D6\\]{
  --tw-gradient-from: #FFF1D6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 241 214 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FFF3CD\\]{
  --tw-gradient-from: #FFF3CD var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 243 205 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FFF5D6\\]{
  --tw-gradient-from: #FFF5D6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 245 214 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FFF7E0\\]{
  --tw-gradient-from: #FFF7E0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 224 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/70{
  --tw-gradient-from: rgb(0 0 0 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/80{
  --tw-gradient-from: rgb(0 0 0 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/85{
  --tw-gradient-from: rgb(0 0 0 / 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500{
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600{
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-600{
  --tw-gradient-from: #16a34a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 163 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white{
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#14C8B0\\]{
  --tw-gradient-to: rgb(20 200 176 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #14C8B0 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#5EEAD4\\]\\/10{
  --tw-gradient-to: rgb(94 234 212 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(94 234 212 / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#5FBAF7\\]{
  --tw-gradient-to: rgb(95 186 247 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #5FBAF7 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/0{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/40{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#0F9D8F\\]{
  --tw-gradient-to: #0F9D8F var(--tw-gradient-to-position);
}
.to-\\[\\#14C8B0\\]{
  --tw-gradient-to: #14C8B0 var(--tw-gradient-to-position);
}
.to-\\[\\#5EEAD4\\]{
  --tw-gradient-to: #5EEAD4 var(--tw-gradient-to-position);
}
.to-\\[\\#5FBAF7\\]{
  --tw-gradient-to: #5FBAF7 var(--tw-gradient-to-position);
}
.to-\\[\\#8F72FF\\]{
  --tw-gradient-to: #8F72FF var(--tw-gradient-to-position);
}
.to-\\[\\#B49CFF\\]{
  --tw-gradient-to: #B49CFF var(--tw-gradient-to-position);
}
.to-\\[\\#BFE9D6\\]{
  --tw-gradient-to: #BFE9D6 var(--tw-gradient-to-position);
}
.to-\\[\\#C3E5EC\\]{
  --tw-gradient-to: #C3E5EC var(--tw-gradient-to-position);
}
.to-\\[\\#D7D2C5\\]{
  --tw-gradient-to: #D7D2C5 var(--tw-gradient-to-position);
}
.to-\\[\\#D9CFFF\\]{
  --tw-gradient-to: #D9CFFF var(--tw-gradient-to-position);
}
.to-\\[\\#EDEAE2\\]{
  --tw-gradient-to: #EDEAE2 var(--tw-gradient-to-position);
}
.to-\\[\\#F4F1E8\\]{
  --tw-gradient-to: #F4F1E8 var(--tw-gradient-to-position);
}
.to-\\[\\#F9C349\\]{
  --tw-gradient-to: #F9C349 var(--tw-gradient-to-position);
}
.to-\\[\\#FF5C49\\]{
  --tw-gradient-to: #FF5C49 var(--tw-gradient-to-position);
}
.to-\\[\\#FFB347\\]{
  --tw-gradient-to: #FFB347 var(--tw-gradient-to-position);
}
.to-\\[\\#FFB6A8\\]{
  --tw-gradient-to: #FFB6A8 var(--tw-gradient-to-position);
}
.to-\\[\\#FFE08A\\]{
  --tw-gradient-to: #FFE08A var(--tw-gradient-to-position);
}
.to-\\[\\#FFE9B0\\]{
  --tw-gradient-to: #FFE9B0 var(--tw-gradient-to-position);
}
.to-\\[\\#FFF1D6\\]{
  --tw-gradient-to: #FFF1D6 var(--tw-gradient-to-position);
}
.to-\\[\\#FFFDF7\\]{
  --tw-gradient-to: #FFFDF7 var(--tw-gradient-to-position);
}
.to-black\\/0{
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
}
.to-emerald-600{
  --tw-gradient-to: #059669 var(--tw-gradient-to-position);
}
.to-indigo-600{
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.bg-clip-text{
  background-clip: text;
}
.fill-\\[\\#F9C349\\]{
  fill: #F9C349;
}
.fill-\\[\\#FF7A6B\\]{
  fill: #FF7A6B;
}
.fill-current{
  fill: currentColor;
}
.fill-primary{
  fill: hsl(var(--primary));
}
.stroke-\\[3\\]{
  stroke-width: 3;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.\\!p-2{
  padding: 0.5rem !important;
}
.\\!p-2\\.5{
  padding: 0.625rem !important;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-3\\.5{
  padding: 0.875rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-7{
  padding: 1.75rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[1px\\]{
  padding: 1px;
}
.\\!px-2{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.\\!px-2\\.5{
  padding-left: 0.625rem !important;
  padding-right: 0.625rem !important;
}
.\\!px-3{
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.\\!px-4{
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.\\!py-0{
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.\\!py-1{
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.\\!py-1\\.5{
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}
.\\!py-2{
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.\\!pl-4{
  padding-left: 1rem !important;
}
.\\!pr-4{
  padding-right: 1rem !important;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-16{
  padding-bottom: 4rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-28{
  padding-bottom: 7rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-32{
  padding-bottom: 8rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pb-\\[96px\\]{
  padding-bottom: 96px;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-11{
  padding-left: 2.75rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pr-1\\.5{
  padding-right: 0.375rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-14{
  padding-right: 3.5rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-3\\.5{
  padding-right: 0.875rem;
}
.pr-36{
  padding-right: 9rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-8{
  padding-right: 2rem;
}
.ps-10{
  padding-inline-start: 2.5rem;
}
.ps-11{
  padding-inline-start: 2.75rem;
}
.ps-3{
  padding-inline-start: 0.75rem;
}
.ps-4{
  padding-inline-start: 1rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-12{
  padding-top: 3rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-20{
  padding-top: 5rem;
}
.pt-24{
  padding-top: 6rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.text-start{
  text-align: start;
}
.text-end{
  text-align: end;
}
.align-middle{
  vertical-align: middle;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans{
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.\\!text-xs{
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-6xl{
  font-size: 3.75rem;
  line-height: 1;
}
.text-8xl{
  font-size: 6rem;
  line-height: 1;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[20px\\]{
  font-size: 20px;
}
.text-\\[26px\\]{
  font-size: 26px;
}
.text-\\[28px\\]{
  font-size: 28px;
}
.text-\\[34px\\]{
  font-size: 34px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.italic{
  font-style: italic;
}
.not-italic{
  font-style: normal;
}
.leading-\\[0\\.88\\]{
  line-height: 0.88;
}
.leading-\\[0\\.92\\]{
  line-height: 0.92;
}
.leading-\\[0\\.95\\]{
  line-height: 0.95;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.18em\\]{
  letter-spacing: 0.18em;
}
.tracking-\\[0\\.2em\\]{
  letter-spacing: 0.2em;
}
.tracking-\\[0\\.3em\\]{
  letter-spacing: 0.3em;
}
.tracking-\\[0\\.4em\\]{
  letter-spacing: 0.4em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#00B4D8\\]{
  --tw-text-opacity: 1;
  color: rgb(0 180 216 / var(--tw-text-opacity, 1));
}
.text-\\[\\#00CE9E\\]{
  --tw-text-opacity: 1;
  color: rgb(0 206 158 / var(--tw-text-opacity, 1));
}
.text-\\[\\#00CED1\\]{
  --tw-text-opacity: 1;
  color: rgb(0 206 209 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0A0B0D\\]{
  --tw-text-opacity: 1;
  color: rgb(10 11 13 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0A5C36\\]{
  --tw-text-opacity: 1;
  color: rgb(10 92 54 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0B0B0F\\]{
  --tw-text-opacity: 1;
  color: rgb(11 11 15 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0F1115\\]{
  --tw-text-opacity: 1;
  color: rgb(15 17 21 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0F9D8F\\]{
  --tw-text-opacity: 1;
  color: rgb(15 157 143 / var(--tw-text-opacity, 1));
}
.text-\\[\\#121212\\]{
  --tw-text-opacity: 1;
  color: rgb(18 18 18 / var(--tw-text-opacity, 1));
}
.text-\\[\\#14C8B0\\]{
  --tw-text-opacity: 1;
  color: rgb(20 200 176 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3D424B\\]{
  --tw-text-opacity: 1;
  color: rgb(61 66 75 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4A3000\\]{
  --tw-text-opacity: 1;
  color: rgb(74 48 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4A4A4A\\]{
  --tw-text-opacity: 1;
  color: rgb(74 74 74 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4A4F58\\]{
  --tw-text-opacity: 1;
  color: rgb(74 79 88 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5B45B0\\]{
  --tw-text-opacity: 1;
  color: rgb(91 69 176 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5FBAF7\\]{
  --tw-text-opacity: 1;
  color: rgb(95 186 247 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5FBAF7\\]\\/50{
  color: rgb(95 186 247 / 0.5);
}
.text-\\[\\#7A5500\\]{
  --tw-text-opacity: 1;
  color: rgb(122 85 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7A7A7A\\]{
  --tw-text-opacity: 1;
  color: rgb(122 122 122 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7C828D\\]{
  --tw-text-opacity: 1;
  color: rgb(124 130 141 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8A8F98\\]{
  --tw-text-opacity: 1;
  color: rgb(138 143 152 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8B2C1A\\]{
  --tw-text-opacity: 1;
  color: rgb(139 44 26 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8B6914\\]{
  --tw-text-opacity: 1;
  color: rgb(139 105 20 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B49CFF\\]{
  --tw-text-opacity: 1;
  color: rgb(180 156 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B9BDC7\\]{
  --tw-text-opacity: 1;
  color: rgb(185 189 199 / var(--tw-text-opacity, 1));
}
.text-\\[\\#D14848\\]{
  --tw-text-opacity: 1;
  color: rgb(209 72 72 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F5B547\\]{
  --tw-text-opacity: 1;
  color: rgb(245 181 71 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F9C349\\]{
  --tw-text-opacity: 1;
  color: rgb(249 195 73 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF4757\\]{
  --tw-text-opacity: 1;
  color: rgb(255 71 87 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF4E5B\\]{
  --tw-text-opacity: 1;
  color: rgb(255 78 91 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF6B6B\\]{
  --tw-text-opacity: 1;
  color: rgb(255 107 107 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF7A6B\\]{
  --tw-text-opacity: 1;
  color: rgb(255 122 107 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFB347\\]{
  --tw-text-opacity: 1;
  color: rgb(255 179 71 / var(--tw-text-opacity, 1));
}
.text-accent-foreground{
  color: hsl(var(--accent-foreground));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-card-foreground{
  color: hsl(var(--card-foreground));
}
.text-current{
  color: currentColor;
}
.text-destructive{
  color: hsl(var(--destructive));
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground));
}
.text-foreground{
  color: hsl(var(--foreground));
}
.text-foreground\\/50{
  color: hsl(var(--foreground) / 0.5);
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-ink{
  --tw-text-opacity: 1;
  color: rgb(10 11 13 / var(--tw-text-opacity, 1));
}
.text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.text-primary{
  color: hsl(var(--primary));
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground));
}
.text-transparent{
  color: transparent;
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/40{
  color: rgb(255 255 255 / 0.4);
}
.text-white\\/50{
  color: rgb(255 255 255 / 0.5);
}
.text-white\\/60{
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/75{
  color: rgb(255 255 255 / 0.75);
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85{
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90{
  color: rgb(255 255 255 / 0.9);
}
.text-zinc-500{
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity, 1));
}
.text-zinc-600{
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.line-through{
  text-decoration-line: line-through;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.placeholder-\\[\\#7C828D\\]::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(124 130 141 / var(--tw-placeholder-opacity, 1));
}
.accent-\\[\\#00CED1\\]{
  accent-color: #00CED1;
}
.accent-\\[\\#FF6B6B\\]{
  accent-color: #FF6B6B;
}
.accent-ink{
  accent-color: #0A0B0D;
}
.opacity-0{
  opacity: 0;
}
.opacity-10{
  opacity: 0.1;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_30px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.45\\)\\]{
  --tw-shadow: 0 10px 30px rgba(0,0,0,0.45);
  --tw-shadow-colored: 0 10px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_6px_16px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.18\\)\\]{
  --tw-shadow: 0 6px 16px rgba(0,0,0,0.18);
  --tw-shadow-colored: 0 6px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_rgba\\(0\\2c 206\\2c 209\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 8px 24px rgba(0,206,209,0.35);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[2px_2px_0_\\#000\\]{
  --tw-shadow: 2px 2px 0 #000;
  --tw-shadow-colored: 2px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[2px_2px_0_\\#121212\\]{
  --tw-shadow: 2px 2px 0 #121212;
  --tw-shadow-colored: 2px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[3px_3px_0_\\#000\\]{
  --tw-shadow: 3px 3px 0 #000;
  --tw-shadow-colored: 3px 3px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[3px_3px_0_\\#121212\\]{
  --tw-shadow: 3px 3px 0 #121212;
  --tw-shadow-colored: 3px 3px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[4px_4px_0_\\#00CED1\\]{
  --tw-shadow: 4px 4px 0 #00CED1;
  --tw-shadow-colored: 4px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[4px_4px_0_\\#121212\\]{
  --tw-shadow: 4px 4px 0 #121212;
  --tw-shadow-colored: 4px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[6px_6px_0_\\#121212\\]{
  --tw-shadow: 6px 6px 0 #121212;
  --tw-shadow-colored: 6px 6px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-blue-600\\/25{
  --tw-shadow-color: rgb(37 99 235 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-black\\/5{
  --tw-ring-color: rgb(0 0 0 / 0.05);
}
.ring-ring{
  --tw-ring-color: hsl(var(--ring));
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background));
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-md{
  --tw-blur: blur(12px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-sm{
  --tw-blur: blur(4px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes enter{
  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{
  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0{
  --tw-enter-opacity: 0;
}
.zoom-in-95{
  --tw-enter-scale: .95;
}
.slide-in-from-bottom-5{
  --tw-enter-translate-y: 1.25rem;
}
.duration-1000{
  animation-duration: 1000ms;
}
.duration-200{
  animation-duration: 200ms;
}
.duration-300{
  animation-duration: 300ms;
}
.duration-500{
  animation-duration: 500ms;
}
.ease-in-out{
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.running{
  animation-play-state: running;
}

:root {
  /* Surface tones */
  --bg: #F7F7F2;
  --bg-2: #EFEEE6;
  --bg-3: #E5E2D6;
  --ink: #0A0B0D;
  --ink-2: #3D424B;
  --ink-3: #7C828D;
  --line: #E2DFD4;
  --line-strong: #0A0B0D;

  /* Brand: TANTA mint → teal */
  --brand: #14C8B0;
  --brand-2: #5EEAD4;
  --brand-3: #0F9D8F;
  --brand-glow: rgba(20, 200, 176, 0.55);
  --accent: #FF7A6B;
  --accent-glow: rgba(255, 122, 107, 0.55);
  --accent-2: #F9C349;

  /* Pastels */
  --pastel-mint: #DDF5EA;
  --pastel-butter: #FFF1D6;
  --pastel-lavender: #ECE6FF;
  --pastel-blush: #FFE6E0;
  --pastel-sky: #DEF1F5;
}

* { border-color: hsl(var(--border)); }

html, body, #root {
  background: var(--bg);
  color: var(--ink);
  font-family: 'DM Sans', system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100%;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

/* Animated aurora background — slow, elegant, brand-aligned */
body {
  position: relative;
  background: var(--bg);
  background-attachment: fixed;
}
body::before {
  content: '';
  position: fixed;
  inset: 0;
  z-index: -2;
  background:
    radial-gradient(60vw 50vw at 12% 10%, rgba(94, 234, 212, 0.35), transparent 60%),
    radial-gradient(50vw 40vw at 90% 0%, rgba(255, 122, 107, 0.22), transparent 60%),
    radial-gradient(70vw 50vw at 50% 100%, rgba(249, 195, 73, 0.18), transparent 60%),
    radial-gradient(40vw 30vw at 100% 80%, rgba(20, 200, 176, 0.28), transparent 60%);
  filter: blur(60px) saturate(140%);
  animation: aurora-drift 30s ease-in-out infinite alternate;
  pointer-events: none;
}
/* Subtle film grain overlay — gives that premium futuristic texture */
body::after {
  content: '';
  position: fixed;
  inset: 0;
  z-index: -1;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  opacity: 0.55;
  mix-blend-mode: multiply;
  pointer-events: none;
}

@keyframes aurora-drift {
  0%   { transform: translate3d(0, 0, 0) rotate(0deg); }
  50%  { transform: translate3d(-3%, 2%, 0) rotate(0.4deg); }
  100% { transform: translate3d(2%, -2%, 0) rotate(-0.4deg); }
}

h1, h2, h3, h4, h5, h6, .font-display {
  font-family: 'Outfit', sans-serif;
  letter-spacing: -0.025em;
}
.font-script { font-family: 'Caveat', cursive; }
.font-mono, .mono-num { font-family: 'JetBrains Mono', ui-monospace, monospace; font-feature-settings: 'tnum' 1, 'cv01' 1; }

/* Modern shadow scale — layered, soft, with optional brand glow */
.shadow-soft   { box-shadow: 0 1px 2px rgba(10, 11, 13, 0.04), 0 6px 14px rgba(10, 11, 13, 0.06); }
.shadow-soft-md{ box-shadow: 0 2px 4px rgba(10, 11, 13, 0.05), 0 14px 32px rgba(10, 11, 13, 0.10); }
.shadow-soft-lg{ box-shadow: 0 6px 14px rgba(10, 11, 13, 0.08), 0 30px 60px rgba(10, 11, 13, 0.14); }
.shadow-glow   { box-shadow: 0 1px 2px rgba(10, 11, 13, 0.10), 0 12px 38px var(--brand-glow); }
.shadow-glow-coral { box-shadow: 0 1px 2px rgba(10, 11, 13, 0.10), 0 12px 38px var(--accent-glow); }
.shadow-glow-gold  { box-shadow: 0 1px 2px rgba(10, 11, 13, 0.10), 0 12px 38px rgba(249, 195, 73, 0.55); }
.shadow-nb     { box-shadow: 4px 4px 0 0 var(--line-strong); }
.shadow-nb-sm  { box-shadow: 2px 2px 0 0 var(--line-strong); }

/* Glass surfaces — premium futuristic blur */
.glass {
  background: rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(22px) saturate(180%);
  -webkit-backdrop-filter: blur(22px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.55);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.7),
    inset 0 -1px 0 rgba(10, 11, 13, 0.04),
    0 8px 24px rgba(10, 11, 13, 0.06);
}
.glass-strong {
  background: rgba(255, 255, 255, 0.78);
  backdrop-filter: blur(28px) saturate(200%);
  -webkit-backdrop-filter: blur(28px) saturate(200%);
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.85),
    inset 0 -1px 0 rgba(10, 11, 13, 0.05),
    0 12px 36px rgba(10, 11, 13, 0.10);
}
.glass-dark {
  background: rgba(10, 11, 13, 0.55);
  backdrop-filter: blur(24px) saturate(180%);
  -webkit-backdrop-filter: blur(24px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: white;
}

/* Buttons */
.btn-nb {
  display: inline-flex; align-items: center; justify-content: center; gap: .5rem;
  border: 1px solid rgba(10, 11, 13, 0.10);
  border-radius: 9999px;
  padding: .6rem 1.15rem; font-weight: 600;
  font-family: 'Outfit', sans-serif; font-size: .9rem;
  background: rgba(255,255,255,0.85);
  backdrop-filter: blur(8px);
  color: var(--ink);
  box-shadow: 0 1px 2px rgba(10, 11, 13, 0.04), 0 2px 6px rgba(10, 11, 13, 0.05);
  transition: transform .2s cubic-bezier(.2,.8,.2,1), box-shadow .2s ease, background .2s ease;
  cursor: pointer; -webkit-user-select: none; user-select: none;
  letter-spacing: -0.01em;
  position: relative;
}
.btn-nb:hover {
  transform: translateY(-1.5px);
  box-shadow: 0 2px 4px rgba(10, 11, 13, 0.06), 0 10px 22px rgba(10, 11, 13, 0.12);
}
.btn-nb:active { transform: translateY(0); box-shadow: 0 1px 2px rgba(10, 11, 13, 0.05); }
.btn-nb[disabled] { opacity: .55; cursor: not-allowed; transform: none; box-shadow: none; }

.btn-nb-primary {
  background: linear-gradient(135deg, var(--brand-2) 0%, var(--brand) 60%, var(--brand-3) 100%);
  color: white; border-color: transparent;
  box-shadow: 0 1px 2px rgba(10,11,13,.10), 0 10px 28px var(--brand-glow), inset 0 1px 0 rgba(255,255,255,.35);
}
.btn-nb-primary:hover {
  box-shadow: 0 2px 6px rgba(10,11,13,.12), 0 16px 36px var(--brand-glow), inset 0 1px 0 rgba(255,255,255,.45);
}
.btn-nb-info {
  background: linear-gradient(135deg, #67E8F9, #06B6D4);
  color: white; border-color: transparent;
  box-shadow: 0 1px 2px rgba(10,11,13,.10), 0 10px 28px rgba(6, 182, 212, 0.45), inset 0 1px 0 rgba(255,255,255,.35);
}
.btn-nb-warn {
  background: linear-gradient(135deg, #FFE08A, #F9C349);
  color: #4A3000; border-color: transparent;
  box-shadow: 0 1px 2px rgba(10,11,13,.10), 0 10px 28px rgba(249, 195, 73, 0.45), inset 0 1px 0 rgba(255,255,255,.45);
}
.btn-nb-dark {
  background: linear-gradient(135deg, #1F2228 0%, #0A0B0D 100%);
  color: white; border-color: transparent;
  box-shadow: 0 1px 2px rgba(10,11,13,.20), 0 10px 28px rgba(10, 11, 13, 0.45), inset 0 1px 0 rgba(255,255,255,.10);
}
.btn-nb-coral {
  background: linear-gradient(135deg, #FFA89C, var(--accent));
  color: white; border-color: transparent;
  box-shadow: 0 1px 2px rgba(10,11,13,.10), 0 10px 28px var(--accent-glow), inset 0 1px 0 rgba(255,255,255,.30);
}

/* Cards */
.card-nb {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(10, 11, 13, 0.06);
  border-radius: 24px;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.85),
    0 1px 2px rgba(10, 11, 13, 0.04),
    0 10px 30px rgba(10, 11, 13, 0.08);
  transition: transform .3s cubic-bezier(.2,.8,.2,1), box-shadow .3s ease;
}

/* Inputs */
.input-nb {
  width: 100%;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(8px);
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: .75rem 1rem;
  font-family: 'DM Sans', sans-serif;
  font-size: 16px; /* 16px prevents iOS Safari from auto-zooming on focus */
  color: var(--ink);
  outline: none;
  transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
}
input, select, textarea {
  font-size: 16px !important;
}
.input-nb::placeholder { color: var(--ink-3); }
.input-nb:focus {
  border-color: var(--brand);
  background: white;
  box-shadow: 0 0 0 4px rgba(20, 200, 176, 0.18), 0 1px 2px rgba(10, 11, 13, 0.04);
}

/* Tags / pills */
.tag-nb {
  display: inline-flex; align-items: center; gap: 4px;
  border: 1px solid rgba(10, 11, 13, 0.08);
  border-radius: 9999px;
  padding: 3px 10px;
  font-weight: 600;
  font-size: .72rem;
  background: rgba(255,255,255,0.85);
  backdrop-filter: blur(8px);
  color: var(--ink);
  white-space: nowrap;
  letter-spacing: .01em;
}

/* Scrollbar */
.scroll-hide::-webkit-scrollbar { display: none; }
.scroll-hide { -ms-overflow-style: none; scrollbar-width: none; }
::-webkit-scrollbar { width: 10px; height: 10px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: rgba(10,11,13,0.15); border-radius: 9999px; border: 2px solid transparent; background-clip: padding-box; }
::-webkit-scrollbar-thumb:hover { background: rgba(10,11,13,0.30); border: 2px solid transparent; background-clip: padding-box; }

/* Animations */
@keyframes pop-in {
  0% { opacity: 0; transform: translateY(12px) scale(.97); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
}
.animate-pop { animation: pop-in .5s cubic-bezier(.2,.8,.2,1) both; }

@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}
.animate-shimmer {
  background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.5) 50%, transparent 100%);
  background-size: 200% 100%;
  animation: shimmer 2.4s ease-in-out infinite;
}

@keyframes float {
  0%,100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}
.animate-float { animation: float 4s ease-in-out infinite; }

@keyframes pulse-glow {
  0%,100% { box-shadow: 0 0 0 0 rgba(20, 200, 176, 0.5), 0 10px 28px var(--brand-glow); }
  50%     { box-shadow: 0 0 0 12px rgba(20, 200, 176, 0), 0 14px 36px var(--brand-glow); }
}
.animate-pulse-glow { animation: pulse-glow 2.4s ease-in-out infinite; }

@keyframes glide-up {
  0% { opacity: 0; transform: translateY(20px); }
  100% { opacity: 1; transform: translateY(0); }
}
.animate-glide { animation: glide-up .7s cubic-bezier(.2,.8,.2,1) both; }

::selection { background: var(--brand); color: white; }

/* Focus-visible polish */
:focus-visible { outline: 2px solid var(--brand); outline-offset: 3px; border-radius: 8px; }

/* Subtle gradient border utility */
.border-gradient {
  position: relative;
}
.border-gradient::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 1px;
  background: linear-gradient(135deg, var(--brand-2), var(--brand), var(--accent));
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  pointer-events: none;
}

/* Mono number style for stats and balances */
.stat-num {
  font-family: 'JetBrains Mono', ui-monospace, monospace;
  font-feature-settings: 'tnum' 1, 'cv01' 1;
  font-weight: 700;
  letter-spacing: -0.02em;
}

/* RTL support — when document.dir is rtl, flip a few essentials */
[dir="rtl"] .text-left { text-align: right; }
[dir="rtl"] .text-right { text-align: left; }
[dir="rtl"] {
  font-family: 'DM Sans', 'IBM Plex Sans Arabic', 'Vazirmatn', system-ui, sans-serif;
}


/* ===================== Profile shop customizations ===================== */

/* Animated name gradient (used by certain name_style items) */
@keyframes name-shift {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}
.name-gradient {
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  background-size: 200% 200%;
}
.name-gradient.animated { animation: name-shift 5s ease-in-out infinite; }

/* Avatar decoration rings */
.avatar-ring {
  position: relative;
  padding: 4px;
  border-radius: 9999px;
  display: inline-block;
}
.avatar-ring > img,
.avatar-ring > div,
.avatar-ring > button { border: 2px solid #121212; }
@keyframes ring-rotate { to { transform: rotate(360deg); } }
.avatar-ring.rotating::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 9999px;
  background: inherit;
  animation: ring-rotate 6s linear infinite;
  z-index: -1;
}

/* Profile banner */
.profile-banner {
  height: 110px;
  border-radius: 20px;
  border: 2px solid #121212;
  box-shadow: 4px 4px 0 #121212;
  margin-bottom: -52px;
  background-size: cover;
  background-position: center;
}

/* Profile effects */
.fx-sparkle {
  position: relative;
  overflow: hidden;
}
.fx-sparkle::after {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    radial-gradient(circle 2px at 20% 30%, #fff7d6 30%, transparent 31%),
    radial-gradient(circle 1.5px at 65% 70%, #fff7d6 30%, transparent 31%),
    radial-gradient(circle 2px at 80% 20%, #fff7d6 30%, transparent 31%),
    radial-gradient(circle 1.5px at 40% 80%, #fff7d6 30%, transparent 31%),
    radial-gradient(circle 2px at 90% 60%, #fff7d6 30%, transparent 31%);
  animation: sparkle-twinkle 2.4s ease-in-out infinite;
  mix-blend-mode: screen;
  opacity: .85;
}
@keyframes sparkle-twinkle {
  0%, 100% { opacity: .35; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.05); }
}

.fx-pulse { animation: card-pulse 3s ease-in-out infinite; }
@keyframes card-pulse {
  0%, 100% { box-shadow: 4px 4px 0 #121212, 0 0 0 0 rgba(20,200,176,0.6); }
  50% { box-shadow: 4px 4px 0 #121212, 0 0 36px 6px rgba(20,200,176,0.45); }
}

.fx-confetti {
  position: relative;
  overflow: hidden;
}
.fx-confetti::before {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    radial-gradient(circle 4px at 10% 15%, #f59e0b 50%, transparent 51%),
    radial-gradient(circle 3px at 30% 45%, #ec4899 50%, transparent 51%),
    radial-gradient(circle 4px at 70% 25%, #22d3ee 50%, transparent 51%),
    radial-gradient(circle 3px at 85% 65%, #a3e635 50%, transparent 51%),
    radial-gradient(circle 4px at 55% 85%, #7c3aed 50%, transparent 51%);
  animation: confetti-fall 4s linear infinite;
  opacity: .85;
}
@keyframes confetti-fall {
  from { transform: translateY(-10%); }
  to { transform: translateY(110%); }
}

.fx-aurora { position: relative; overflow: hidden; }
.fx-aurora::after {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    radial-gradient(ellipse 60% 30% at 30% 20%, rgba(124,58,237,.35), transparent 60%),
    radial-gradient(ellipse 50% 25% at 70% 80%, rgba(34,211,238,.35), transparent 60%),
    radial-gradient(ellipse 40% 20% at 50% 50%, rgba(236,72,153,.30), transparent 60%);
  animation: aurora-drift 8s ease-in-out infinite alternate;
}

/* Name badge */
.name-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 9999px;
  border: 2px solid #121212;
  background: #fff;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

/* ── Auth page animated background ─────────────────────────────────────── */
.auth-page-root {
  background: #FFFDF7;
}

.auth-bg-gradient {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 80% 60% at 20% 10%, rgba(20,200,176,0.08) 0%, transparent 60%),
    radial-gradient(ellipse 60% 50% at 80% 90%, rgba(108,71,255,0.06) 0%, transparent 55%),
    radial-gradient(ellipse 50% 40% at 60% 30%, rgba(94,234,212,0.05) 0%, transparent 50%);
  pointer-events: none;
}

.auth-bg-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  pointer-events: none;
  animation: orb-drift 12s ease-in-out infinite alternate;
}

.orb-1 {
  width: 500px; height: 500px;
  background: radial-gradient(circle, rgba(20,200,176,0.10) 0%, transparent 70%);
  top: -120px; left: -100px;
  animation-duration: 14s;
}

.orb-2 {
  width: 400px; height: 400px;
  background: radial-gradient(circle, rgba(108,71,255,0.07) 0%, transparent 70%);
  bottom: -80px; right: -80px;
  animation-duration: 10s;
  animation-delay: -4s;
}

.orb-3 {
  width: 300px; height: 300px;
  background: radial-gradient(circle, rgba(249,195,73,0.06) 0%, transparent 70%);
  top: 40%; left: 40%;
  animation-duration: 16s;
  animation-delay: -8s;
}

@keyframes orb-drift {
  0%   { transform: translate(0, 0) scale(1); }
  50%  { transform: translate(30px, -40px) scale(1.05); }
  100% { transform: translate(-20px, 30px) scale(0.97); }
}

.file\\:border-0::file-selector-button{
  border-width: 0px;
}

.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}

.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.file\\:font-medium::file-selector-button{
  font-weight: 500;
}

.file\\:text-foreground::file-selector-button{
  color: hsl(var(--foreground));
}

.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}

.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}

.after\\:inset-y-0::after{
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}

.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}

.after\\:w-1::after{
  content: var(--tw-content);
  width: 0.25rem;
}

.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.first\\:rounded-l-md:first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.first\\:border-l:first-child{
  border-left-width: 1px;
}

.last\\:rounded-r-md:last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.last\\:border-0:last-child{
  border-width: 0px;
}

.focus-within\\:relative:focus-within{
  position: relative;
}

.focus-within\\:z-20:focus-within{
  z-index: 20;
}

.hover\\:-translate-y-0\\.5:hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:-translate-y-1:hover{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:translate-x-\\[2px\\]:hover{
  --tw-translate-x: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:translate-y-\\[-1px\\]:hover{
  --tw-translate-y: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:translate-y-\\[1px\\]:hover{
  --tw-translate-y: 1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:translate-y-\\[2px\\]:hover{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-125:hover{
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-\\[\\#14C8B0\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(20 200 176 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#B49CFF\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(180 156 255 / var(--tw-border-opacity, 1));
}

.hover\\:bg-\\[\\#0A0B0D\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(10 11 13 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#0F1115\\]\\/5:hover{
  background-color: rgb(15 17 21 / 0.05);
}

.hover\\:bg-\\[\\#0F9D8F\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(15 157 143 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#14C8B0\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(20 200 176 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#B83333\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(184 51 51 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#E9E5D7\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(233 229 215 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#EDEDE9\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(237 237 233 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#EFEEE6\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 238 230 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#F0EFE7\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 239 231 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#F4F1E8\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(244 241 232 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#F4F1EA\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(244 241 234 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#F4F2ED\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(244 242 237 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#F7F7F2\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#FAF8F2\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 248 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#FFE6E0\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 230 224 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#FFF5F3\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 245 243 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#FFFDF7\\]\\/50:hover{
  background-color: rgb(255 253 247 / 0.5);
}

.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent));
}

.hover\\:bg-black\\/5:hover{
  background-color: rgb(0 0 0 / 0.05);
}

.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-destructive\\/80:hover{
  background-color: hsl(var(--destructive) / 0.8);
}

.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}

.hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-muted:hover{
  background-color: hsl(var(--muted));
}

.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5);
}

.hover\\:bg-primary:hover{
  background-color: hsl(var(--primary));
}

.hover\\:bg-primary\\/80:hover{
  background-color: hsl(var(--primary) / 0.8);
}

.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9);
}

.hover\\:bg-secondary:hover{
  background-color: hsl(var(--secondary));
}

.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}

.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white\\/10:hover{
  background-color: rgb(255 255 255 / 0.1);
}

.hover\\:bg-white\\/20:hover{
  background-color: rgb(255 255 255 / 0.2);
}

.hover\\:bg-white\\/25:hover{
  background-color: rgb(255 255 255 / 0.25);
}

.hover\\:bg-zinc-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-zinc-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 231 / var(--tw-bg-opacity, 1));
}

.hover\\:text-\\[\\#0A0B0D\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(10 11 13 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#0F1115\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(15 17 21 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#0F9D8F\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(15 157 143 / var(--tw-text-opacity, 1));
}

.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground));
}

.hover\\:text-black:hover{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.hover\\:text-foreground:hover{
  color: hsl(var(--foreground));
}

.hover\\:text-muted-foreground:hover{
  color: hsl(var(--muted-foreground));
}

.hover\\:text-primary-foreground:hover{
  color: hsl(var(--primary-foreground));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover{
  opacity: 1;
}

.hover\\:opacity-90:hover{
  opacity: 0.9;
}

.hover\\:shadow-\\[1px_1px_0_\\#000\\]:hover{
  --tw-shadow: 1px 1px 0 #000;
  --tw-shadow-colored: 1px 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[2px_2px_0_\\#000\\]:hover{
  --tw-shadow: 2px 2px 0 #000;
  --tw-shadow-colored: 2px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[2px_2px_0_\\#00CED1\\]:hover{
  --tw-shadow: 2px 2px 0 #00CED1;
  --tw-shadow-colored: 2px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-xl:hover{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:brightness-125:hover{
  --tw-brightness: brightness(1.25);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.hover\\:brightness-95:hover{
  --tw-brightness: brightness(.95);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.focus\\:border-\\[\\#00CED1\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(0 206 209 / var(--tw-border-opacity, 1));
}

.focus\\:border-\\[\\#0F9D8F\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(15 157 143 / var(--tw-border-opacity, 1));
}

.focus\\:border-\\[\\#14C8B0\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(20 200 176 / var(--tw-border-opacity, 1));
}

.focus\\:bg-\\[\\#E9E5D7\\]:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(233 229 215 / var(--tw-bg-opacity, 1));
}

.focus\\:bg-accent:focus{
  background-color: hsl(var(--accent));
}

.focus\\:bg-primary:focus{
  background-color: hsl(var(--primary));
}

.focus\\:text-accent-foreground:focus{
  color: hsl(var(--accent-foreground));
}

.focus\\:text-primary-foreground:focus{
  color: hsl(var(--primary-foreground));
}

.focus\\:opacity-100:focus{
  opacity: 1;
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-4:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-\\[\\#14C8B0\\]:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(20 200 176 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-ring:focus{
  --tw-ring-color: hsl(var(--ring));
}

.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-1:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring));
}

.focus-visible\\:ring-offset-1:focus-visible{
  --tw-ring-offset-width: 1px;
}

.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-offset-background:focus-visible{
  --tw-ring-offset-color: hsl(var(--background));
}

.active\\:translate-y-\\[1px\\]:active{
  --tw-translate-y: 1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:translate-y-\\[2px\\]:active{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-90:active{
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-95:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:cursor-grabbing:active{
  cursor: grabbing;
}

.active\\:bg-\\[\\#F4F1E8\\]:active{
  --tw-bg-opacity: 1;
  background-color: rgb(244 241 232 / var(--tw-bg-opacity, 1));
}

.active\\:bg-\\[\\#FFE6E0\\]:active{
  --tw-bg-opacity: 1;
  background-color: rgb(255 230 224 / var(--tw-bg-opacity, 1));
}

.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}

.disabled\\:opacity-35:disabled{
  opacity: 0.35;
}

.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}

.disabled\\:shadow-none:disabled{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.disabled\\:active\\:scale-100:active:disabled{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:bg-black\\/30{
  background-color: rgb(0 0 0 / 0.3);
}

.group:hover .group-hover\\:text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}

.group\\/author:hover .group-hover\\/author\\:underline{
  text-decoration-line: underline;
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40{
  border-color: hsl(var(--muted) / 0.4);
}

.group.toaster .group-\\[\\.toaster\\]\\:border-border{
  border-color: hsl(var(--border));
}

.group.toast .group-\\[\\.toast\\]\\:bg-muted{
  background-color: hsl(var(--muted));
}

.group.toast .group-\\[\\.toast\\]\\:bg-primary{
  background-color: hsl(var(--primary));
}

.group.toaster .group-\\[\\.toaster\\]\\:bg-background{
  background-color: hsl(var(--background));
}

.group.destructive .group-\\[\\.destructive\\]\\:text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground{
  color: hsl(var(--muted-foreground));
}

.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground{
  color: hsl(var(--primary-foreground));
}

.group.toaster .group-\\[\\.toaster\\]\\:text-foreground{
  color: hsl(var(--foreground));
}

.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover{
  border-color: hsl(var(--destructive) / 0.3);
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover{
  background-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover{
  color: hsl(var(--destructive-foreground));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover{
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus{
  --tw-ring-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus{
  --tw-ring-offset-color: #dc2626;
}

.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed;
}

.peer:disabled ~ .peer-disabled\\:opacity-70{
  opacity: 0.7;
}

.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled){
  opacity: 0.5;
}

.aria-selected\\:bg-accent[aria-selected="true"]{
  background-color: hsl(var(--accent));
}

.aria-selected\\:bg-accent\\/50[aria-selected="true"]{
  background-color: hsl(var(--accent) / 0.5);
}

.aria-selected\\:text-accent-foreground[aria-selected="true"]{
  color: hsl(var(--accent-foreground));
}

.aria-selected\\:text-muted-foreground[aria-selected="true"]{
  color: hsl(var(--muted-foreground));
}

.aria-selected\\:opacity-100[aria-selected="true"]{
  opacity: 1;
}

.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none;
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}

.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"]{
  height: 1px;
}

.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"]{
  width: 100%;
}

.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"]{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]{
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]{
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes accordion-up{
  from{
    height: var(--radix-accordion-content-height);
  }
  to{
    height: 0;
  }
}

.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"]{
  animation: accordion-up 0.2s ease-out;
}

@keyframes accordion-down{
  from{
    height: 0;
  }
  to{
    height: var(--radix-accordion-content-height);
  }
}

.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"]{
  animation: accordion-down 0.2s ease-out;
}

.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"]{
  flex-direction: column;
}

.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
  background-color: hsl(var(--background));
}

.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
  background-color: hsl(var(--primary));
}

.data-\\[state\\=on\\]\\:bg-accent[data-state="on"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"]{
  background-color: hsl(var(--accent) / 0.5);
}

.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
  background-color: hsl(var(--secondary));
}

.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
  background-color: hsl(var(--muted));
}

.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]{
  background-color: hsl(var(--input));
}

.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder]{
  color: hsl(var(--muted-foreground));
}

.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"]{
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
  color: hsl(var(--foreground));
}

.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"]{
  color: hsl(var(--primary-foreground));
}

.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"]{
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"]{
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"]{
  color: hsl(var(--muted-foreground));
}

.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
  opacity: 0.5;
}

.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}

.data-\\[state\\=active\\]\\:shadow[data-state="active"]{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"]{
  transition-property: none;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  transition-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  transition-duration: 500ms;
}

.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"]{
  --tw-enter-opacity: 0;
}

.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"]{
  --tw-exit-opacity: 0;
}

.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0;
}

.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"]{
  --tw-exit-opacity: 0.8;
}

.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"]{
  --tw-exit-opacity: 0;
}

.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0;
}

.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"]{
  --tw-enter-opacity: 0;
}

.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95;
}

.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"]{
  --tw-enter-scale: .9;
}

.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95;
}

.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"]{
  --tw-enter-translate-x: 13rem;
}

.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"]{
  --tw-enter-translate-x: -13rem;
}

.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"]{
  --tw-exit-translate-x: 13rem;
}

.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"]{
  --tw-exit-translate-x: -13rem;
}

.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem;
}

.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem;
}

.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem;
}

.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem;
}

.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
  --tw-exit-translate-y: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
  --tw-exit-translate-x: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
  --tw-exit-translate-x: -50%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
  --tw-exit-translate-y: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
  --tw-exit-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
  --tw-enter-translate-y: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
  --tw-enter-translate-x: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
  --tw-enter-translate-x: -50%;
}

.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
  --tw-enter-translate-x: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
  --tw-enter-translate-y: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
  --tw-enter-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"]{
  --tw-enter-translate-y: -100%;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  animation-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  animation-duration: 500ms;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  left: 0px;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  height: 0.25rem;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  width: 100%;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=open\\]\\:hover\\:bg-accent:hover[data-state="open"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:focus\\:bg-accent:focus[data-state="open"]{
  background-color: hsl(var(--accent));
}

.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.dark\\:border-destructive:is(.dark *){
  border-color: hsl(var(--destructive));
}

.dark\\:border-zinc-600:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(82 82 91 / var(--tw-border-opacity, 1));
}

.dark\\:border-zinc-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(39 39 42 / var(--tw-border-opacity, 1));
}

.dark\\:bg-blue-900\\/30:is(.dark *){
  background-color: rgb(30 58 138 / 0.3);
}

.dark\\:bg-green-900\\/40:is(.dark *){
  background-color: rgb(20 83 45 / 0.4);
}

.dark\\:bg-red-900\\/30:is(.dark *){
  background-color: rgb(127 29 29 / 0.3);
}

.dark\\:bg-zinc-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-zinc-800:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-zinc-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / var(--tw-bg-opacity, 1));
}

.dark\\:text-green-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.dark\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-zinc-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(244 244 245 / var(--tw-text-opacity, 1));
}

.dark\\:text-zinc-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(212 212 216 / var(--tw-text-opacity, 1));
}

.dark\\:text-zinc-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:bg-zinc-700:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-zinc-800:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity, 1));
}

@media (min-width: 640px){
  .sm\\:bottom-0{
    bottom: 0px;
  }
  .sm\\:bottom-4{
    bottom: 1rem;
  }
  .sm\\:bottom-6{
    bottom: 1.5rem;
  }
  .sm\\:left-auto{
    left: auto;
  }
  .sm\\:right-0{
    right: 0px;
  }
  .sm\\:right-6{
    right: 1.5rem;
  }
  .sm\\:right-\\[calc\\(50\\%-225px\\)\\]{
    right: calc(50% - 225px);
  }
  .sm\\:top-auto{
    top: auto;
  }
  .sm\\:-mx-6{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
  .sm\\:mx-6{
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
  .sm\\:-mt-5{
    margin-top: -1.25rem;
  }
  .sm\\:mt-0{
    margin-top: 0px;
  }
  .sm\\:block{
    display: block;
  }
  .sm\\:inline{
    display: inline;
  }
  .sm\\:inline-flex{
    display: inline-flex;
  }
  .sm\\:h-10{
    height: 2.5rem;
  }
  .sm\\:h-12{
    height: 3rem;
  }
  .sm\\:h-16{
    height: 4rem;
  }
  .sm\\:h-32{
    height: 8rem;
  }
  .sm\\:h-5{
    height: 1.25rem;
  }
  .sm\\:h-6{
    height: 1.5rem;
  }
  .sm\\:h-\\[18px\\]{
    height: 18px;
  }
  .sm\\:h-\\[500px\\]{
    height: 500px;
  }
  .sm\\:w-10{
    width: 2.5rem;
  }
  .sm\\:w-12{
    width: 3rem;
  }
  .sm\\:w-16{
    width: 4rem;
  }
  .sm\\:w-32{
    width: 8rem;
  }
  .sm\\:w-5{
    width: 1.25rem;
  }
  .sm\\:w-6{
    width: 1.5rem;
  }
  .sm\\:w-80{
    width: 20rem;
  }
  .sm\\:w-\\[18px\\]{
    width: 18px;
  }
  .sm\\:max-w-full{
    max-width: 100%;
  }
  .sm\\:max-w-lg{
    max-width: 32rem;
  }
  .sm\\:max-w-md{
    max-width: 28rem;
  }
  .sm\\:max-w-sm{
    max-width: 24rem;
  }
  .sm\\:auto-rows-\\[160px\\]{
    grid-auto-rows: 160px;
  }
  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .sm\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .sm\\:flex-row{
    flex-direction: row;
  }
  .sm\\:flex-col{
    flex-direction: column;
  }
  .sm\\:items-center{
    align-items: center;
  }
  .sm\\:justify-end{
    justify-content: flex-end;
  }
  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }
  .sm\\:gap-3{
    gap: 0.75rem;
  }
  .sm\\:gap-4{
    gap: 1rem;
  }
  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }
  .sm\\:rounded-3xl{
    border-radius: 1.5rem;
  }
  .sm\\:rounded-lg{
    border-radius: var(--radius);
  }
  .sm\\:border-4{
    border-width: 4px;
  }
  .sm\\:p-1\\.5{
    padding: 0.375rem;
  }
  .sm\\:p-3{
    padding: 0.75rem;
  }
  .sm\\:p-4{
    padding: 1rem;
  }
  .sm\\:p-6{
    padding: 1.5rem;
  }
  .sm\\:p-8{
    padding: 2rem;
  }
  .sm\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\\:py-1\\.5{
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }
  .sm\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .sm\\:pb-32{
    padding-bottom: 8rem;
  }
  .sm\\:pb-6{
    padding-bottom: 1.5rem;
  }
  .sm\\:pb-\\[104px\\]{
    padding-bottom: 104px;
  }
  .sm\\:pr-0{
    padding-right: 0px;
  }
  .sm\\:pt-6{
    padding-top: 1.5rem;
  }
  .sm\\:text-left{
    text-align: left;
  }
  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .sm\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }
  .sm\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }
  .sm\\:text-7xl{
    font-size: 4.5rem;
    line-height: 1;
  }
  .sm\\:text-\\[24px\\]{
    font-size: 24px;
  }
  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .sm\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"]{
    --tw-enter-translate-y: 100%;
  }
}

@media (min-width: 768px){
  .md\\:absolute{
    position: absolute;
  }
  .md\\:max-h-\\[92vh\\]{
    max-height: 92vh;
  }
  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
    width: var(--radix-navigation-menu-viewport-width);
  }
  .md\\:w-auto{
    width: auto;
  }
  .md\\:max-w-\\[420px\\]{
    max-width: 420px;
  }
  .md\\:max-w-xl{
    max-width: 36rem;
  }
  .md\\:auto-rows-\\[180px\\]{
    grid-auto-rows: 180px;
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .md\\:grid-cols-\\[1\\.2fr_1fr\\]{
    grid-template-columns: 1.2fr 1fr;
  }
  .md\\:flex-row{
    flex-direction: row;
  }
  .md\\:items-center{
    align-items: center;
  }
  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (min-width: 1024px){
  .lg\\:bottom-3{
    bottom: 0.75rem;
  }
  .lg\\:order-1{
    order: 1;
  }
  .lg\\:order-2{
    order: 2;
  }
  .lg\\:col-span-5{
    grid-column: span 5 / span 5;
  }
  .lg\\:col-span-7{
    grid-column: span 7 / span 7;
  }
  .lg\\:-mx-10{
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }
  .lg\\:mx-8{
    margin-left: 2rem;
    margin-right: 2rem;
  }
  .lg\\:-mt-6{
    margin-top: -1.5rem;
  }
  .lg\\:mt-1{
    margin-top: 0.25rem;
  }
  .lg\\:mt-20{
    margin-top: 5rem;
  }
  .lg\\:grid{
    display: grid;
  }
  .lg\\:h-5{
    height: 1.25rem;
  }
  .lg\\:h-7{
    height: 1.75rem;
  }
  .lg\\:h-\\[26px\\]{
    height: 26px;
  }
  .lg\\:h-\\[560px\\]{
    height: 560px;
  }
  .lg\\:w-7{
    width: 1.75rem;
  }
  .lg\\:w-\\[26px\\]{
    width: 26px;
  }
  .lg\\:max-w-3xl{
    max-width: 48rem;
  }
  .lg\\:max-w-\\[1960px\\]{
    max-width: 1960px;
  }
  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .lg\\:flex-row{
    flex-direction: row;
  }
  .lg\\:gap-10{
    gap: 2.5rem;
  }
  .lg\\:gap-12{
    gap: 3rem;
  }
  .lg\\:p-2{
    padding: 0.5rem;
  }
  .lg\\:p-7{
    padding: 1.75rem;
  }
  .lg\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .lg\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }
  .lg\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .lg\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .lg\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .lg\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .lg\\:py-24{
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
  .lg\\:py-28{
    padding-top: 7rem;
    padding-bottom: 7rem;
  }
  .lg\\:py-3\\.5{
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }
  .lg\\:py-32{
    padding-top: 8rem;
    padding-bottom: 8rem;
  }
  .lg\\:pb-20{
    padding-bottom: 5rem;
  }
  .lg\\:pt-16{
    padding-top: 4rem;
  }
  .lg\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .lg\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }
  .lg\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }
  .lg\\:text-7xl{
    font-size: 4.5rem;
    line-height: 1;
  }
  .lg\\:text-\\[100px\\]{
    font-size: 100px;
  }
  .lg\\:text-\\[13px\\]{
    font-size: 13px;
  }
}

@media (min-width: 1280px){
  .xl\\:text-\\[84px\\]{
    font-size: 84px;
  }
}

.\\[\\&\\+div\\]\\:text-xs+div{
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start){
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]){
  border-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]){
  background-color: hsl(var(--accent));
}

.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside){
  background-color: hsl(var(--accent) / 0.5);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px;
}

.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox]{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\>svg\\]\\:absolute>svg{
  position: absolute;
}

.\\[\\&\\>svg\\]\\:left-4>svg{
  left: 1rem;
}

.\\[\\&\\>svg\\]\\:top-4>svg{
  top: 1rem;
}

.\\[\\&\\>svg\\]\\:size-4>svg{
  width: 1rem;
  height: 1rem;
}

.\\[\\&\\>svg\\]\\:h-3\\.5>svg{
  height: 0.875rem;
}

.\\[\\&\\>svg\\]\\:w-3\\.5>svg{
  width: 0.875rem;
}

.\\[\\&\\>svg\\]\\:shrink-0>svg{
  flex-shrink: 0;
}

.\\[\\&\\>svg\\]\\:text-destructive>svg{
  color: hsl(var(--destructive));
}

.\\[\\&\\>svg\\]\\:text-foreground>svg{
  color: hsl(var(--foreground));
}

.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
  padding-left: 1.75rem;
}

.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px;
}

.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
  font-weight: 500;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading]{
  color: hsl(var(--muted-foreground));
}

.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
  padding-top: 0px;
}

.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg{
  height: 1.25rem;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg{
  width: 1.25rem;
}

.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
  height: 3rem;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
  height: 1.25rem;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
  width: 1.25rem;
}

.\\[\\&_p\\]\\:leading-relaxed p{
  line-height: 1.625;
}

.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}

.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem;
  height: 1rem;
}

.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}

.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px;
}

.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px;
}


`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AACA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;;CAAc;AAAd;;;CAAc;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;EAAA,gBAAc;AAAA;AAAd;;;;;;;;CAAc;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,iCAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,mBAAc;AAAA;AAAd;;;;;CAAc;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;AAAd;EAAA,eAAc;AAAA;AAAd;EAAA,WAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,oBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,aAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,YAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,kBAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;AAAd;EAAA,UAAc;AAAA;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;;CAAc;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAAd;IAAA,wBAAc;IAAd,wBAAc;IAAd,iBAAc;IAAd,6BAAc;IAAd,oBAAc;IAAd,gCAAc;IAAd,sBAAc;IAAd,+BAAc;IAAd,uBAAc;IAAd,kCAAc;IAAd,mBAAc;IAAd,8BAAc;IAAd,oBAAc;IAAd,8BAAc;IAAd,wBAAc;IAAd,mCAAc;IAAd,oBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,iBAAc;EAAA;AAEd;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;;EAEtB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,iBAAiB;EACjB,wCAAwC;EACxC,mBAAmB;;EAEnB,YAAY;EACZ,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;AACvB;;AA2BA,IAAI,gCAAgC,EAAE;;AAEtC;EACE,qBAAqB;EACrB,iBAAiB;EACjB,6CAA6C;EAC7C,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,WAAW;EACX;;;;qFAImF;EACnF,iCAAiC;EACjC,0DAA0D;EAC1D,oBAAoB;AACtB;AACA,sEAAsE;AACtE;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,WAAW;EACX,yDAAwW;EACxW,aAAa;EACb,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,OAAO,4CAA4C,EAAE;EACrD,OAAO,iDAAiD,EAAE;EAC1D,OAAO,kDAAkD,EAAE;AAC7D;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;AACA,eAAe,8BAA8B,EAAE;AAC/C,wBAAwB,sDAAsD,EAAE,yCAAyC,EAAE;;AAE3H,kEAAkE;AAClE,iBAAiB,+EAA+E,EAAE;AAClG,iBAAiB,gFAAgF,EAAE;AACnG,iBAAiB,iFAAiF,EAAE;AACpG,iBAAiB,2EAA2E,EAAE;AAC9F,qBAAqB,4EAA4E,EAAE;AACnG,qBAAqB,kFAAkF,EAAE;AACzG,iBAAiB,0CAA0C,EAAE;AAC7D,iBAAiB,0CAA0C,EAAE;;AAE7D,6CAA6C;AAC7C;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,2CAA2C;EAC3C;;;qCAGmC;AACrC;AACA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,0CAA0C;EAC1C;;;sCAGoC;AACtC;AACA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,kDAAkD;EAClD,2CAA2C;EAC3C,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,UAAU;EAC9E,wCAAwC;EACxC,qBAAqB;EACrB,sBAAsB,EAAE,gBAAgB;EACxC,iCAAiC,EAAE,gBAAgB;EACnD,kCAAkC;EAClC,0BAA0B;EAC1B,iBAAiB;EACjB,8EAA8E;EAC9E,4FAA4F;EAC5F,eAAe,EAAE,yBAAiB,EAAjB,iBAAiB;EAClC,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,gFAAgF;AAClF;AACA,iBAAiB,wBAAwB,EAAE,4CAA4C,EAAE;AACzF,oBAAoB,YAAY,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAE1F;EACE,6FAA6F;EAC7F,YAAY,EAAE,yBAAyB;EACvC,4GAA4G;AAC9G;AACA;EACE,4GAA4G;AAC9G;AACA;EACE,qDAAqD;EACrD,YAAY,EAAE,yBAAyB;EACvC,kHAAkH;AACpH;AACA;EACE,qDAAqD;EACrD,cAAc,EAAE,yBAAyB;EACzC,mHAAmH;AACrH;AACA;EACE,6DAA6D;EAC7D,YAAY,EAAE,yBAAyB;EACvC,iHAAiH;AACnH;AACA;EACE,2DAA2D;EAC3D,YAAY,EAAE,yBAAyB;EACvC,6GAA6G;AAC/G;;AAEA,UAAU;AACV;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,wCAAwC;EACxC,mBAAmB;EACnB;;;sCAGoC;EACpC,uEAAuE;AACzE;;AAEA,WAAW;AACX;EACE,WAAW;EACX,oCAAoC;EACpC,0BAA0B;EAC1B,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;EAClC,eAAe,EAAE,wDAAwD;EACzE,iBAAiB;EACjB,aAAa;EACb,2EAA2E;AAC7E;AACA;EACE,0BAA0B;AAC5B;AACA,yBAAyB,mBAAmB,EAAE;AAC9C;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gFAAgF;AAClF;;AAEA,iBAAiB;AACjB;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,wCAAwC;EACxC,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,cAAc;AACd,kCAAkC,aAAa,EAAE;AACjD,eAAe,wBAAwB,EAAE,qBAAqB,EAAE;AAChE,sBAAsB,WAAW,EAAE,YAAY,EAAE;AACjD,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,+BAA+B,EAAE,qBAAqB,EAAE,6BAA6B,EAAE,4BAA4B,EAAE;AACjJ,kCAAkC,+BAA+B,EAAE,6BAA6B,EAAE,4BAA4B,EAAE;;AAEhI,eAAe;AACf;EACE,KAAK,UAAU,EAAE,sCAAsC,EAAE;EACzD,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;AACA,eAAe,mDAAmD,EAAE;;AAEpE;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;AACA;EACE,+FAA+F;EAC/F,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,UAAU,wBAAwB,EAAE;EACpC,MAAM,2BAA2B,EAAE;AACrC;AACA,iBAAiB,wCAAwC,EAAE;;AAE3D;EACE,UAAU,0EAA0E,EAAE;EACtF,UAAU,2EAA2E,EAAE;AACzF;AACA,sBAAsB,+CAA+C,EAAE;;AAEvE;EACE,KAAK,UAAU,EAAE,2BAA2B,EAAE;EAC9C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA,iBAAiB,qDAAqD,EAAE;;AAExE,cAAc,wBAAwB,EAAE,YAAY,EAAE;;AAEtD,yBAAyB;AACzB,iBAAiB,+BAA+B,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;;AAE3F,mCAAmC;AACnC;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,YAAY;EACZ,gFAAgF;EAChF,8EAA8E;EAEtE,uBAAuB;EAC/B,oBAAoB;AACtB;;AAEA,6CAA6C;AAC7C;EACE,sDAAsD;EACtD,yCAAyC;EACzC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,kEAAkE;AAClE,yBAAyB,iBAAiB,EAAE;AAC5C,0BAA0B,gBAAgB,EAAE;AAC5C;EACE,kFAAkF;AACpF;;;AAGA,4EAA4E;;AAE5E,8DAA8D;AAC9D;EACE,WAAW,2BAA2B,EAAE;EACxC,MAAM,6BAA6B,EAAE;AACvC;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;AAC5B;AACA,0BAA0B,6CAA6C,EAAE;;AAEzE,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;AACvB;AACA;;wBAEwB,yBAAyB,EAAE;AACnD,yBAAyB,KAAK,yBAAyB,EAAE,EAAE;AAC3D;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB;;;;;wEAKsE;EACtE,oDAAoD;EACpD,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,WAAW,YAAY,EAAE,mBAAmB,EAAE;EAC9C,MAAM,UAAU,EAAE,sBAAsB,EAAE;AAC5C;;AAEA,YAAY,6CAA6C,EAAE;AAC3D;EACE,WAAW,2DAA2D,EAAE;EACxE,MAAM,iEAAiE,EAAE;AAC3E;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB;;;;;wEAKsE;EACtE,2CAA2C;EAC3C,YAAY;AACd;AACA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,2BAA2B,EAAE;AACpC;;AAEA,aAAa,kBAAkB,EAAE,gBAAgB,EAAE;AACnD;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB;;;sFAGoF;EACpF,yDAAyD;AAC3D;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,6EAA6E;AAC7E;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;0FAGwF;EACxF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,uDAAuD;AACzD;;AAEA;EACE,YAAY,EAAE,aAAa;EAC3B,8EAA8E;EAC9E,WAAW,EAAE,YAAY;EACzB,uBAAuB;AACzB;;AAEA;EACE,YAAY,EAAE,aAAa;EAC3B,8EAA8E;EAC9E,aAAa,EAAE,YAAY;EAC3B,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,YAAY,EAAE,aAAa;EAC3B,8EAA8E;EAC9E,QAAQ,EAAE,SAAS;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,OAAO,mCAAmC,EAAE;EAC5C,OAAO,6CAA6C,EAAE;EACtD,OAAO,6CAA6C,EAAE;AACxD;;AA5gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,mBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,0BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,0BA+gBA;EA/gBA,QA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,0BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,0BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,0BA+gBA;EA/gBA,sBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,iDA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,kDA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,2BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,0BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,qBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,sBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,qBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,qBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,sBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,sBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,2BA+gBA;EA/gBA,qDA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,2BA+gBA;EA/gBA,qDA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,8BA+gBA;EA/gBA,qDA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,gFA+gBA;EA/gBA,oGA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,iCA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,gCA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,sBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,sBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,sBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,8BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,2GA+gBA;EA/gBA,yGA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,2GA+gBA;EA/gBA,yGA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,2GA+gBA;EA/gBA,yGA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,2GA+gBA;EA/gBA,yGA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,8BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,2GA+gBA;EA/gBA,yGA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,2GA+gBA;EA/gBA,yGA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,qBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,qBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,gBA+gBA;EA/gBA,gBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,iBA+gBA;EA/gBA,iBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,sBA+gBA;EA/gBA,8BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,eA+gBA;EA/gBA,eA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,+EA+gBA;EA/gBA,mGA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,yBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,0BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,yBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,0BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,sBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,qBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,qBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,gDA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,iDA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;AAAA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;AAAA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,0EA+gBA;EA/gBA,8FA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,qBA+gBA;EA/gBA,yBA+gBA;EA/gBA,2BA+gBA;EA/gBA,yBA+gBA;EA/gBA,0BA+gBA;EA/gBA,+BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,qBA+gBA;EA/gBA,yBA+gBA;EA/gBA,2BA+gBA;EA/gBA,yBA+gBA;EA/gBA,0BA+gBA;EA/gBA,+BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,qBA+gBA;EA/gBA,yBA+gBA;EA/gBA,2BA+gBA;EA/gBA,yBA+gBA;EA/gBA,0BA+gBA;EA/gBA,+BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA,yBA+gBA;EA/gBA,0BA+gBA;EA/gBA,wBA+gBA;EA/gBA,yBA+gBA;EA/gBA,8BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA,yBA+gBA;EA/gBA,0BA+gBA;EA/gBA,wBA+gBA;EA/gBA,yBA+gBA;EA/gBA,8BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA,yBA+gBA;EA/gBA,0BA+gBA;EA/gBA,wBA+gBA;EA/gBA,yBA+gBA;EA/gBA,8BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA,yBA+gBA;EA/gBA,0BA+gBA;EA/gBA,wBA+gBA;EA/gBA,yBA+gBA;EA/gBA,8BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,0BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,0BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,0BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,0BA+gBA;EA/gBA,sBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,0BA+gBA;EA/gBA,qBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,mBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,sBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,sBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA,oBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,mBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA,uBA+gBA;IA/gBA,sDA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,uBA+gBA;IA/gBA,oDA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,uBA+gBA;IA/gBA,2DA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA,qBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,qBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,oBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,qBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,oBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA,iBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,mBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,kBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,eA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,kBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,iBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA,eA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,mBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,mBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,kBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,kBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA;EA+gBA;AAAA;;AA/gBA;EAAA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA,mBA+gBA;IA/gBA;EA+gBA;AAAA;;AA/gBA;EAAA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA,oBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,iBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA,oBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,kBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,kBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,oBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,kBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,mBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,mBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,iBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,iBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,qBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,iBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA,kBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,eA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,kBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA,iBA+gBA;IA/gBA;EA+gBA;EA/gBA;IAAA;EA+gBA;EA/gBA;IAAA;EA+gBA;AAAA;;AA/gBA;EAAA;IAAA;EA+gBA;AAAA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kDA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,iDA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,iDA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kDA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,kDA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,qBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,gBA+gBA;EA/gBA,oBA+gBA;EA/gBA,4BA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,sBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,WA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,mBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,qBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,kBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA,oBA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA,WA+gBA;EA/gBA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA;;AA/gBA;EAAA;AA+gBA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800;900&family=DM+Sans:wght@400;500;600;700&family=Caveat:wght@400;700&family=JetBrains+Mono:wght@400;500;600;700&display=swap');\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n:root {\n  /* Surface tones */\n  --bg: #F7F7F2;\n  --bg-2: #EFEEE6;\n  --bg-3: #E5E2D6;\n  --ink: #0A0B0D;\n  --ink-2: #3D424B;\n  --ink-3: #7C828D;\n  --line: #E2DFD4;\n  --line-strong: #0A0B0D;\n\n  /* Brand: TANTA mint → teal */\n  --brand: #14C8B0;\n  --brand-2: #5EEAD4;\n  --brand-3: #0F9D8F;\n  --brand-glow: rgba(20, 200, 176, 0.55);\n  --accent: #FF7A6B;\n  --accent-glow: rgba(255, 122, 107, 0.55);\n  --accent-2: #F9C349;\n\n  /* Pastels */\n  --pastel-mint: #DDF5EA;\n  --pastel-butter: #FFF1D6;\n  --pastel-lavender: #ECE6FF;\n  --pastel-blush: #FFE6E0;\n  --pastel-sky: #DEF1F5;\n}\n\n@layer base {\n  :root {\n    --background: 60 25% 97%;\n    --foreground: 222 13% 5%;\n    --card: 0 0% 100%;\n    --card-foreground: 222 13% 5%;\n    --popover: 0 0% 100%;\n    --popover-foreground: 222 13% 5%;\n    --primary: 173 80% 43%;\n    --primary-foreground: 0 0% 100%;\n    --secondary: 60 14% 92%;\n    --secondary-foreground: 222 13% 5%;\n    --muted: 60 14% 92%;\n    --muted-foreground: 220 9% 50%;\n    --accent: 9 100% 71%;\n    --accent-foreground: 0 0% 100%;\n    --destructive: 0 80% 60%;\n    --destructive-foreground: 0 0% 100%;\n    --border: 38 24% 89%;\n    --input: 38 24% 89%;\n    --ring: 173 80% 43%;\n    --radius: 1.25rem;\n  }\n}\n\n* { border-color: hsl(var(--border)); }\n\nhtml, body, #root {\n  background: var(--bg);\n  color: var(--ink);\n  font-family: 'DM Sans', system-ui, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  min-height: 100%;\n  width: 100%;\n  max-width: 100vw;\n  overflow-x: hidden;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* Animated aurora background — slow, elegant, brand-aligned */\nbody {\n  position: relative;\n  background: var(--bg);\n  background-attachment: fixed;\n}\nbody::before {\n  content: '';\n  position: fixed;\n  inset: 0;\n  z-index: -2;\n  background:\n    radial-gradient(60vw 50vw at 12% 10%, rgba(94, 234, 212, 0.35), transparent 60%),\n    radial-gradient(50vw 40vw at 90% 0%, rgba(255, 122, 107, 0.22), transparent 60%),\n    radial-gradient(70vw 50vw at 50% 100%, rgba(249, 195, 73, 0.18), transparent 60%),\n    radial-gradient(40vw 30vw at 100% 80%, rgba(20, 200, 176, 0.28), transparent 60%);\n  filter: blur(60px) saturate(140%);\n  animation: aurora-drift 30s ease-in-out infinite alternate;\n  pointer-events: none;\n}\n/* Subtle film grain overlay — gives that premium futuristic texture */\nbody::after {\n  content: '';\n  position: fixed;\n  inset: 0;\n  z-index: -1;\n  background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\");\n  opacity: 0.55;\n  mix-blend-mode: multiply;\n  pointer-events: none;\n}\n\n@keyframes aurora-drift {\n  0%   { transform: translate3d(0, 0, 0) rotate(0deg); }\n  50%  { transform: translate3d(-3%, 2%, 0) rotate(0.4deg); }\n  100% { transform: translate3d(2%, -2%, 0) rotate(-0.4deg); }\n}\n\nh1, h2, h3, h4, h5, h6, .font-display {\n  font-family: 'Outfit', sans-serif;\n  letter-spacing: -0.025em;\n}\n.font-script { font-family: 'Caveat', cursive; }\n.font-mono, .mono-num { font-family: 'JetBrains Mono', ui-monospace, monospace; font-feature-settings: 'tnum' 1, 'cv01' 1; }\n\n/* Modern shadow scale — layered, soft, with optional brand glow */\n.shadow-soft   { box-shadow: 0 1px 2px rgba(10, 11, 13, 0.04), 0 6px 14px rgba(10, 11, 13, 0.06); }\n.shadow-soft-md{ box-shadow: 0 2px 4px rgba(10, 11, 13, 0.05), 0 14px 32px rgba(10, 11, 13, 0.10); }\n.shadow-soft-lg{ box-shadow: 0 6px 14px rgba(10, 11, 13, 0.08), 0 30px 60px rgba(10, 11, 13, 0.14); }\n.shadow-glow   { box-shadow: 0 1px 2px rgba(10, 11, 13, 0.10), 0 12px 38px var(--brand-glow); }\n.shadow-glow-coral { box-shadow: 0 1px 2px rgba(10, 11, 13, 0.10), 0 12px 38px var(--accent-glow); }\n.shadow-glow-gold  { box-shadow: 0 1px 2px rgba(10, 11, 13, 0.10), 0 12px 38px rgba(249, 195, 73, 0.55); }\n.shadow-nb     { box-shadow: 4px 4px 0 0 var(--line-strong); }\n.shadow-nb-sm  { box-shadow: 2px 2px 0 0 var(--line-strong); }\n\n/* Glass surfaces — premium futuristic blur */\n.glass {\n  background: rgba(255, 255, 255, 0.55);\n  backdrop-filter: blur(22px) saturate(180%);\n  -webkit-backdrop-filter: blur(22px) saturate(180%);\n  border: 1px solid rgba(255, 255, 255, 0.55);\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.7),\n    inset 0 -1px 0 rgba(10, 11, 13, 0.04),\n    0 8px 24px rgba(10, 11, 13, 0.06);\n}\n.glass-strong {\n  background: rgba(255, 255, 255, 0.78);\n  backdrop-filter: blur(28px) saturate(200%);\n  -webkit-backdrop-filter: blur(28px) saturate(200%);\n  border: 1px solid rgba(255, 255, 255, 0.6);\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.85),\n    inset 0 -1px 0 rgba(10, 11, 13, 0.05),\n    0 12px 36px rgba(10, 11, 13, 0.10);\n}\n.glass-dark {\n  background: rgba(10, 11, 13, 0.55);\n  backdrop-filter: blur(24px) saturate(180%);\n  -webkit-backdrop-filter: blur(24px) saturate(180%);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  color: white;\n}\n\n/* Buttons */\n.btn-nb {\n  display: inline-flex; align-items: center; justify-content: center; gap: .5rem;\n  border: 1px solid rgba(10, 11, 13, 0.10);\n  border-radius: 9999px;\n  padding: .6rem 1.15rem; font-weight: 600;\n  font-family: 'Outfit', sans-serif; font-size: .9rem;\n  background: rgba(255,255,255,0.85);\n  backdrop-filter: blur(8px);\n  color: var(--ink);\n  box-shadow: 0 1px 2px rgba(10, 11, 13, 0.04), 0 2px 6px rgba(10, 11, 13, 0.05);\n  transition: transform .2s cubic-bezier(.2,.8,.2,1), box-shadow .2s ease, background .2s ease;\n  cursor: pointer; user-select: none;\n  letter-spacing: -0.01em;\n  position: relative;\n}\n.btn-nb:hover {\n  transform: translateY(-1.5px);\n  box-shadow: 0 2px 4px rgba(10, 11, 13, 0.06), 0 10px 22px rgba(10, 11, 13, 0.12);\n}\n.btn-nb:active { transform: translateY(0); box-shadow: 0 1px 2px rgba(10, 11, 13, 0.05); }\n.btn-nb[disabled] { opacity: .55; cursor: not-allowed; transform: none; box-shadow: none; }\n\n.btn-nb-primary {\n  background: linear-gradient(135deg, var(--brand-2) 0%, var(--brand) 60%, var(--brand-3) 100%);\n  color: white; border-color: transparent;\n  box-shadow: 0 1px 2px rgba(10,11,13,.10), 0 10px 28px var(--brand-glow), inset 0 1px 0 rgba(255,255,255,.35);\n}\n.btn-nb-primary:hover {\n  box-shadow: 0 2px 6px rgba(10,11,13,.12), 0 16px 36px var(--brand-glow), inset 0 1px 0 rgba(255,255,255,.45);\n}\n.btn-nb-info {\n  background: linear-gradient(135deg, #67E8F9, #06B6D4);\n  color: white; border-color: transparent;\n  box-shadow: 0 1px 2px rgba(10,11,13,.10), 0 10px 28px rgba(6, 182, 212, 0.45), inset 0 1px 0 rgba(255,255,255,.35);\n}\n.btn-nb-warn {\n  background: linear-gradient(135deg, #FFE08A, #F9C349);\n  color: #4A3000; border-color: transparent;\n  box-shadow: 0 1px 2px rgba(10,11,13,.10), 0 10px 28px rgba(249, 195, 73, 0.45), inset 0 1px 0 rgba(255,255,255,.45);\n}\n.btn-nb-dark {\n  background: linear-gradient(135deg, #1F2228 0%, #0A0B0D 100%);\n  color: white; border-color: transparent;\n  box-shadow: 0 1px 2px rgba(10,11,13,.20), 0 10px 28px rgba(10, 11, 13, 0.45), inset 0 1px 0 rgba(255,255,255,.10);\n}\n.btn-nb-coral {\n  background: linear-gradient(135deg, #FFA89C, var(--accent));\n  color: white; border-color: transparent;\n  box-shadow: 0 1px 2px rgba(10,11,13,.10), 0 10px 28px var(--accent-glow), inset 0 1px 0 rgba(255,255,255,.30);\n}\n\n/* Cards */\n.card-nb {\n  background: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(10, 11, 13, 0.06);\n  border-radius: 24px;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.85),\n    0 1px 2px rgba(10, 11, 13, 0.04),\n    0 10px 30px rgba(10, 11, 13, 0.08);\n  transition: transform .3s cubic-bezier(.2,.8,.2,1), box-shadow .3s ease;\n}\n\n/* Inputs */\n.input-nb {\n  width: 100%;\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(8px);\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  padding: .75rem 1rem;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 16px; /* 16px prevents iOS Safari from auto-zooming on focus */\n  color: var(--ink);\n  outline: none;\n  transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;\n}\ninput, select, textarea {\n  font-size: 16px !important;\n}\n.input-nb::placeholder { color: var(--ink-3); }\n.input-nb:focus {\n  border-color: var(--brand);\n  background: white;\n  box-shadow: 0 0 0 4px rgba(20, 200, 176, 0.18), 0 1px 2px rgba(10, 11, 13, 0.04);\n}\n\n/* Tags / pills */\n.tag-nb {\n  display: inline-flex; align-items: center; gap: 4px;\n  border: 1px solid rgba(10, 11, 13, 0.08);\n  border-radius: 9999px;\n  padding: 3px 10px;\n  font-weight: 600;\n  font-size: .72rem;\n  background: rgba(255,255,255,0.85);\n  backdrop-filter: blur(8px);\n  color: var(--ink);\n  white-space: nowrap;\n  letter-spacing: .01em;\n}\n\n/* Scrollbar */\n.scroll-hide::-webkit-scrollbar { display: none; }\n.scroll-hide { -ms-overflow-style: none; scrollbar-width: none; }\n::-webkit-scrollbar { width: 10px; height: 10px; }\n::-webkit-scrollbar-track { background: transparent; }\n::-webkit-scrollbar-thumb { background: rgba(10,11,13,0.15); border-radius: 9999px; border: 2px solid transparent; background-clip: padding-box; }\n::-webkit-scrollbar-thumb:hover { background: rgba(10,11,13,0.30); border: 2px solid transparent; background-clip: padding-box; }\n\n/* Animations */\n@keyframes pop-in {\n  0% { opacity: 0; transform: translateY(12px) scale(.97); }\n  100% { opacity: 1; transform: translateY(0) scale(1); }\n}\n.animate-pop { animation: pop-in .5s cubic-bezier(.2,.8,.2,1) both; }\n\n@keyframes shimmer {\n  0% { background-position: -200% 0; }\n  100% { background-position: 200% 0; }\n}\n.animate-shimmer {\n  background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.5) 50%, transparent 100%);\n  background-size: 200% 100%;\n  animation: shimmer 2.4s ease-in-out infinite;\n}\n\n@keyframes float {\n  0%,100% { transform: translateY(0); }\n  50% { transform: translateY(-5px); }\n}\n.animate-float { animation: float 4s ease-in-out infinite; }\n\n@keyframes pulse-glow {\n  0%,100% { box-shadow: 0 0 0 0 rgba(20, 200, 176, 0.5), 0 10px 28px var(--brand-glow); }\n  50%     { box-shadow: 0 0 0 12px rgba(20, 200, 176, 0), 0 14px 36px var(--brand-glow); }\n}\n.animate-pulse-glow { animation: pulse-glow 2.4s ease-in-out infinite; }\n\n@keyframes glide-up {\n  0% { opacity: 0; transform: translateY(20px); }\n  100% { opacity: 1; transform: translateY(0); }\n}\n.animate-glide { animation: glide-up .7s cubic-bezier(.2,.8,.2,1) both; }\n\n::selection { background: var(--brand); color: white; }\n\n/* Focus-visible polish */\n:focus-visible { outline: 2px solid var(--brand); outline-offset: 3px; border-radius: 8px; }\n\n/* Subtle gradient border utility */\n.border-gradient {\n  position: relative;\n}\n.border-gradient::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  padding: 1px;\n  background: linear-gradient(135deg, var(--brand-2), var(--brand), var(--accent));\n  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n          mask-composite: exclude;\n  pointer-events: none;\n}\n\n/* Mono number style for stats and balances */\n.stat-num {\n  font-family: 'JetBrains Mono', ui-monospace, monospace;\n  font-feature-settings: 'tnum' 1, 'cv01' 1;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n/* RTL support — when document.dir is rtl, flip a few essentials */\n[dir=\"rtl\"] .text-left { text-align: right; }\n[dir=\"rtl\"] .text-right { text-align: left; }\n[dir=\"rtl\"] {\n  font-family: 'DM Sans', 'IBM Plex Sans Arabic', 'Vazirmatn', system-ui, sans-serif;\n}\n\n\n/* ===================== Profile shop customizations ===================== */\n\n/* Animated name gradient (used by certain name_style items) */\n@keyframes name-shift {\n  0%, 100% { background-position: 0% 50%; }\n  50% { background-position: 100% 50%; }\n}\n.name-gradient {\n  background-clip: text;\n  -webkit-background-clip: text;\n  color: transparent;\n  -webkit-text-fill-color: transparent;\n  background-size: 200% 200%;\n}\n.name-gradient.animated { animation: name-shift 5s ease-in-out infinite; }\n\n/* Avatar decoration rings */\n.avatar-ring {\n  position: relative;\n  padding: 4px;\n  border-radius: 9999px;\n  display: inline-block;\n}\n.avatar-ring > img,\n.avatar-ring > div,\n.avatar-ring > button { border: 2px solid #121212; }\n@keyframes ring-rotate { to { transform: rotate(360deg); } }\n.avatar-ring.rotating::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: 9999px;\n  background: inherit;\n  animation: ring-rotate 6s linear infinite;\n  z-index: -1;\n}\n\n/* Profile banner */\n.profile-banner {\n  height: 110px;\n  border-radius: 20px;\n  border: 2px solid #121212;\n  box-shadow: 4px 4px 0 #121212;\n  margin-bottom: -52px;\n  background-size: cover;\n  background-position: center;\n}\n\n/* Profile effects */\n.fx-sparkle {\n  position: relative;\n  overflow: hidden;\n}\n.fx-sparkle::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background:\n    radial-gradient(circle 2px at 20% 30%, #fff7d6 30%, transparent 31%),\n    radial-gradient(circle 1.5px at 65% 70%, #fff7d6 30%, transparent 31%),\n    radial-gradient(circle 2px at 80% 20%, #fff7d6 30%, transparent 31%),\n    radial-gradient(circle 1.5px at 40% 80%, #fff7d6 30%, transparent 31%),\n    radial-gradient(circle 2px at 90% 60%, #fff7d6 30%, transparent 31%);\n  animation: sparkle-twinkle 2.4s ease-in-out infinite;\n  mix-blend-mode: screen;\n  opacity: .85;\n}\n@keyframes sparkle-twinkle {\n  0%, 100% { opacity: .35; transform: scale(1); }\n  50% { opacity: 1; transform: scale(1.05); }\n}\n\n.fx-pulse { animation: card-pulse 3s ease-in-out infinite; }\n@keyframes card-pulse {\n  0%, 100% { box-shadow: 4px 4px 0 #121212, 0 0 0 0 rgba(20,200,176,0.6); }\n  50% { box-shadow: 4px 4px 0 #121212, 0 0 36px 6px rgba(20,200,176,0.45); }\n}\n\n.fx-confetti {\n  position: relative;\n  overflow: hidden;\n}\n.fx-confetti::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background:\n    radial-gradient(circle 4px at 10% 15%, #f59e0b 50%, transparent 51%),\n    radial-gradient(circle 3px at 30% 45%, #ec4899 50%, transparent 51%),\n    radial-gradient(circle 4px at 70% 25%, #22d3ee 50%, transparent 51%),\n    radial-gradient(circle 3px at 85% 65%, #a3e635 50%, transparent 51%),\n    radial-gradient(circle 4px at 55% 85%, #7c3aed 50%, transparent 51%);\n  animation: confetti-fall 4s linear infinite;\n  opacity: .85;\n}\n@keyframes confetti-fall {\n  from { transform: translateY(-10%); }\n  to { transform: translateY(110%); }\n}\n\n.fx-aurora { position: relative; overflow: hidden; }\n.fx-aurora::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background:\n    radial-gradient(ellipse 60% 30% at 30% 20%, rgba(124,58,237,.35), transparent 60%),\n    radial-gradient(ellipse 50% 25% at 70% 80%, rgba(34,211,238,.35), transparent 60%),\n    radial-gradient(ellipse 40% 20% at 50% 50%, rgba(236,72,153,.30), transparent 60%);\n  animation: aurora-drift 8s ease-in-out infinite alternate;\n}\n\n/* Name badge */\n.name-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  border: 2px solid #121212;\n  background: #fff;\n  font-size: 11px;\n  font-weight: 800;\n  line-height: 1.2;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n/* ── Auth page animated background ─────────────────────────────────────── */\n.auth-page-root {\n  background: #FFFDF7;\n}\n\n.auth-bg-gradient {\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(ellipse 80% 60% at 20% 10%, rgba(20,200,176,0.08) 0%, transparent 60%),\n    radial-gradient(ellipse 60% 50% at 80% 90%, rgba(108,71,255,0.06) 0%, transparent 55%),\n    radial-gradient(ellipse 50% 40% at 60% 30%, rgba(94,234,212,0.05) 0%, transparent 50%);\n  pointer-events: none;\n}\n\n.auth-bg-orb {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(80px);\n  pointer-events: none;\n  animation: orb-drift 12s ease-in-out infinite alternate;\n}\n\n.orb-1 {\n  width: 500px; height: 500px;\n  background: radial-gradient(circle, rgba(20,200,176,0.10) 0%, transparent 70%);\n  top: -120px; left: -100px;\n  animation-duration: 14s;\n}\n\n.orb-2 {\n  width: 400px; height: 400px;\n  background: radial-gradient(circle, rgba(108,71,255,0.07) 0%, transparent 70%);\n  bottom: -80px; right: -80px;\n  animation-duration: 10s;\n  animation-delay: -4s;\n}\n\n.orb-3 {\n  width: 300px; height: 300px;\n  background: radial-gradient(circle, rgba(249,195,73,0.06) 0%, transparent 70%);\n  top: 40%; left: 40%;\n  animation-duration: 16s;\n  animation-delay: -8s;\n}\n\n@keyframes orb-drift {\n  0%   { transform: translate(0, 0) scale(1); }\n  50%  { transform: translate(30px, -40px) scale(1.05); }\n  100% { transform: translate(-20px, 30px) scale(0.97); }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
